/* Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @rushstack/typedef-var */

// @ts-nocheck

//in theory if we get "all" strings in here, we could replace this file with another language version and the entire app would be translated
// since it operates at "compile time" for the most part, we'd pull that off with a custom build and a seperate subdomain for that language

//-------------------------------------------------- START OF STRING CONSTANTS COMING FROM COMMON FILE --------------------------------------------------
export const TEST_STRING = `test string`;
export const TEST_ARGS = (a1) => `start of ${a1}`;

export const TICKET_TYPE = 'Type';
export const TICKET_TYPE_TASK = 'Task';
export const TICKET_TYPE_MILESTONE = 'Milestone';
export const TICKET_TYPE_CONSTRAINT_UNASSIGNED = 'Constraint';
export const TICKET_TYPE_CONSTRAINT_ASSIGNED = 'Assigned Constraint';
export const TICKET_TYPE_CONSTRAINT_ACCEPTED = 'Accepted Constraint';

// nav bar menu
export const SUPPORT_MENU_FAQS = 'Knowledge Base';
export const SUPPORT_MENU_LIVE_CHAT = 'Live Chat';
export const HOW_CAN_WE_HELP_YOU = 'How can we help you?';
export const API_SETTINGS = 'API Settings';

//General warnings
/** Warning displayed when trying to load into a plan you don't have access to or doesn't exist. */
export const PROJECT_ACCESS_ON_LOAD =
	"You don't have project access or project doesn't exist. Returning to Projects list.";

//Drag to Drafts (f.k.a. floating space, etc.)

/** Warning displayed when trying to drag a completed ticket into the floating space */
export const DRAG_COMPLETED_TO_FLOATING = `Can\'t move completed tickets to Drafts`;
/** the title of the popup when trying to drag constrains into the floating space */
export const DRAG_CONSTRAINT_TO_FLOATING_PROMPT_TITLE = `One (or more) of these tickets is a constraint`;
/** the description of the popup when trying to drag constrains into the floating space */
export const DRAG_CONSTRAINT_TO_FLOATING_PROMPT_DESCRIPTION = `Constraints will be removed from the rest of the project until moved back into a plan.  Continue?`;
/** the title of the popup when trying to drag a ticket with dependencies into the floating space */
export const DRAG_DEPENDENCY_TO_FLOATING_PROMPT_TITLE = `One (or more) of these tickets has a dependency`;
/** the description of the popup when trying to drag a ticket with dependencies into the floating space */
export const DRAG_DEPENDENCY_TO_FLOATING_PROMPT_DESCRIPTION = `Remove the dependency and complete the move to Drafts?`;
/** displayed when trying to drag a promised ticket into the floating space */
export const DRAG_PROMISED_INTO_FLOATING = `Can\'t move promised tickets to Drafts`;
/** displayed when trying to drag a ticket with attachments into the floating space */
export const DRAG_ATTACHE_INTO_FLOATING = `Tickets with attachments can\'t be moved to Drafts`;

/** displayed when dragging id-conflicting tickets from drafts to the plan surface */
export const DRAG_DUPLICATE_TICKET_IDS_TITLE = 'Duplicate ticket IDs';
export const DRAG_DUPLICATE_TICKET_IDS_DESCRIPTION = `
Some of the tickets you are moving have the same internal ID</br>
as tickets already on the plan. Touchplan will generate new</br>
IDs for the moved tickets when you add them to the plan.
`;
export const DRAG_DUPLICATE_TICKET_IDS_OK = 'ADD TO PLAN';
export const DRAG_DUPLICATE_TICKET_IDS_CANCEL = 'CANCEL';

/** displayed when trying to drag a pinned ticket across the active line. Logged once per drag if applicable */
export const PINNED_TICKETS_DRAGGED_TO_ACTIVE = `Pinned tickets can\'t be dragged across the active line`;
/** displayed when trying to drag tickets and the active line is modified during the drag */
export const ACTIVE_LINE_MODIFIED_DURING_DRAG = `Active line was modified, so your tickets' positions have been reset. Try dragging again.`;

// Validator
export const VALIDATOR_DRAG_TOO_FAR_AWAY =
	'You are attempting to place a ticket too far away from others in your plan. Click on "Search / Filter" to locate your existing tickets.';
export const ACTIVE_LINE_PIN_RIGHT_HEADER = 'Date is after the active line';
export const ACTIVE_LINE_PIN_RIGHT = "Promise period can't extend to right side of active line";
export const ACTIVE_LINE_START_DATE =
	"You can't use the calendar to set the Start date to after the active line date. To do so, drag ticket across the active line.";

//Dependency warnings

/** Warning triggered when you tap a completed ticket when setting dependencies */
export const SET_DEPENDENCY_TO_ACTUAL = (ticketName) => `Can\'t make a completed ticket a predecessor`;
/** Warning triggered when you have a completed ticket selected and try to set other tickets as predecessors */
export const SET_DEPENDENCY_FROM_ACTUAL = `Can\'t change precedence of a completed ticket`;
/** trigged when trying to set the opposite of an already existing dependency */
export const SET_DEPENDENCY_TO_OPPOSITE = (ticketName) =>
	`Making "${ticketName}" a predecessor would create a loop, since the current ticket is a predecessor of "${ticketName}"`;
/** Warning triggered when a non-admin tries to set a dependency on a ticket they don't own */
export const NON_ADMIN_CANNOT_SET_DEPENDENCY = `You don't have access to set predecessors on the selected ticket`;

// *** Dependency mode looks like DEAD CODE - remove next 3 constants? ***

// Dependency mode prompts
/** displayed in the dependency prompt */
export const DEPENDENCY_PROMPT_DESCRIPTION = `Tap a ticket to toggle it on or off as a predecessor to the one you are editing. <br /><br /> Tap and hold a ticket to edit.`;

// Ticket Overlap Loggings
/** Displayed on initial load when ticket count > 1,000 */
export const OVERLAP_FORCE_DISABLED =
	'Ticket overlap disabled because the current plan has over 1,000 tickets';
/** Displayed when the user overrides the ticket overlap when it was forcefully disabled */
export const OVERLAP_FORCE_DISABLED_OVERRIDE =
	'Ticket overlap may cause performance degradation on plans with over 1,000 tickets';

/** Displayed when a large plan is opened */
export const LARGE_PLAN_DETECTED_TEXT =
	'Large plan opened. Tickets completed over 1 month ago are hidden. Ticket Overlap calculation is disabled. Use Advanced Settings to override.';

/** Displayed when the user overrides the completed ticket hiding when it was forcefully disabled */
export const COMPLETED_FORCE_DISABLED_OVERRIDE =
	'Showing completed tickets may cause performance degradation on plans with over 1,000 tickets';
/** Labels for advanced settings panel */
export const ADVANCED_SETTINGS_TICKET_OVERLAP_LABEL = 'Enable ticket overlap';
export const ADVANCED_SETTINGS_COMPLETED_TICKETS_LABEL = 'Show completed tickets';
export const ADVANCED_SETTINGS_DISABLE_WEBGL_LABEL = 'Disable WebGL (Refresh needed)';

export const ENABLE_QUANTITY_TRACKING = 'Enable quantity tracking';
export const QUANTITY_TRACKING_ENABLED = 'Quantity tracking enabled';

export const QUANTITY_TYPE = 'Quantity type';
export const QUANTITY_SITE = 'Quantity grouping';
export const DEFAULT_QUANTITY_TYPE = 'Default Quantity Type';
export const QUANTITY_PLANNED = 'Quantity planned';
export const QUANTITY_ACTUAL = 'Quantity actual';

export const ROLE_LIST_ROLES_MUST_BE_UNIQUE = 'Role name needs to be unique';
export const LOCATION_LIST_MUST_BE_UNIQUE = 'Location name needs to be unique';

// Tapped on Ticket Error notices
/**
 * The notice that displays when you tap on a ticket error (Yellow exclamation icon)
 */
export const PAST_DUE_NOTICE = 'This ticket is past due';
export const PLANNED_LATER_THAN_REQUIRED = 'Planned date is later than Need By date';
/**
 * The notice that displays when you tap on a ticket error (Red dependency error icon)
 */
export const DEPENDENCY_ERROR_NOTICE = 'This ticket is out of sequence';
/**
 * The string for the "Enable Solid Lines" text in the Advanced Settings panel
 */
export const ENABLE_SOLID_LINES_LABEL = 'Enable Solid Lines';

/**
 * The error message string that displays when connection to Intercom could not be established
 */
export const INTERCOM_CONNECTION_ERROR =
	'Something is blocking the connection to live support. Email us at support@touchplan.io.';

/**
 * CONSTRAINTS
 */
export const CONSTRAINT_ON_LOCKED_PLAN = (planState: string) =>
	`This constraint is in a ${planState} plan. Editing of this constraint is limited.`;
export const CONSTRAINT_CANNOT_COMPLETE_ON_PULL_SIDE =
	"Can't mark ticket complete because it is on right side of active line";
/**
 * ACCESS JOIN
 */
export const ACCESS_CODE_QUICK_JOIN_NEED_CODE = 'You need to enter an Access Code';
export const ACCESS_CODE_QUICK_JOIN_INVALID_CODE = 'Invalid Access Code';
export const ACCESS_CODE_ENTER_CODE = 'ENTER ACCESS CODE:';
export const ACCESS_CODE_PLACEHOLDER = 'ex. 12345';
export const ACCESS_CODE_JOIN = 'Join';

/**
 * CREW SIZES
 */
export const CREW_SIZES_ZOOM_IN_MESSAGE = 'Zoom in to see crew sizes';
export const CREW_SIZES_CLOSED_MESSAGE =
	'Crew sizes closed. To reopen, choose "Plan Actions" then "View Crew Sizes"';

//SWIM LANES
/** swim lane being dragged is removed */
export const DRAG_SWIMLANE_REMOVED =
	'Could not save your swim lane changes because another user removed the swim lane';
/** not dragged swim lanes modified mid drag */
export const DRAG_SWIMLANES_MODIFIED =
	'Could not save your swim lane changes because another user edited the swim lane';
/** too small text */
export const SWIMLANE_TOO_SMALL = 'Zoom in to see the swim lane controls';
/** The warning that comes up when trying to close edit on a swim lane when exiting edit. */
export const SWIMLANE_NEEDS_LABEL = 'Swim lane label is required';
/**
 * Notification which appears when you try editing a swim lane when you are not an admin
 */
export const SWIMLANE_NO_EDIT_RIGHTS =
	'Only Admins can edit swim lanes. Contact a project admin for any changes';
export const SWIMLANE_DRAG_TOO_FAR =
	"Can't drag swim lane there as it would be too far away from the rest of your plan";
export const SWIMLANE_DRAG_TO_ABYSS =
	"Can't drag swim lane there as it would be too far away from the rest of your plan";
export const SWIMLANE_CANNOT_CREATE_TO_FAR =
	"Can't create swim lane as it would be too far away from the rest of your plan";

// enable popups
export const REPORT_FAILED_TO_OPEN_WINDOW =
	'Could not open the Report window. Make sure you enable pop-ups in your web browser.';

// Displayed to a user when the ticket textures fail to load correctly.
export const FAILED_TO_LOAD_TICKET_TEXTURES = 'Could not load tickets. Refresh the page to try again.';

export const CONSTRAINT_LINKED_TO_PROCORE = 'Mark this RFI complete in Procore to complete it in Touchplan';
export const PROCORE_UNEXPECTED_ERROR =
	'Unexpected Error: Failed to connect to Procore. Contact Touchplan Support.';
export const PROCORE_PLEASE_SELECT_AN_RFI =
	'To link this constraint to Procore, choose an RFI using the dropdown';

/** appears when trying to set the first day of a task to be a non work day. Special handling for single day tickets */
export const WARNING_SET_START_NONWORK =
	'To adjust the task start date, tap the calendar or drag ticket to replan';
export const WARNING_SET_START_NONWORK_1DAY =
	'To adjust the task start date, tap the calendar or drag ticket to replan.';
/** appears when trying to set the last day of a task to be a non work day when the end date is fixed */
export const WARNING_SET_FINISH_NONWORK_HELD =
	"Can't set task end date to a non-workday when the end date is fixed";

// Multi-edit menu
export const WARNING_CANNOT_MULTI_EDIT_COMPLETED = "Can't Edit All with completed tickets included";
export const WARNING_CANNOT_COPY_ACTIVE_AND_PULL_TO_CLIPBOARD =
	"Can't copy both active and pull tickets to the clipboard";

// Clipboard
export const CLIPBOARD_LABEL = 'Clipboard';
export const DRAG_TO_PASTE_LABEL = 'Drag to Paste';

export const PASTE_MODE_EXACT_COPY = 'Exact Copy';
export const PASTE_MODE_TEMPLATE_ORIGINAL = 'Template - Original';
export const PASTE_MODE_TEMPLATE_CURRENT = 'Template - Current';

export const PASTE_MODES_INFO_POPUP_HEADER = 'Paste modes';
export const PASTE_MODES_INFO_TEXT_AFTER_EXACT_COPY =
	'Combine plans on same dates including statuses, pins, and variance reasons';
export const PASTE_MODES_INFO_TEXT_AFTER_TEMPLATE_CURRENT = 'Create new tickets based on current values';
export const PASTE_MODES_INFO_TEXT_AFTER_TEMPLATE_ORIGINAL = 'Create new tickets based on original values';
export const PASTE_MODES_INFO_TEXT_AFTER_TEMPLATES =
	'Template modes duplicate tickets without statuses, pins, and variance reasons';
export const PASTE_MODES_INFO_CONFIRM_BUTTON = 'OK';

export const WARNING_ACTIVE_TICKETS_AFTER_ACTIVE_LINE_DATE_WERE_NOT_PASTED = (
	badTicketCount,
	totalCount,
	maxClipboardDate
) =>
	`Some tickets were not pasted because they included dates beyond the current active line<br/><br/>Excluded ${badTicketCount} of ${totalCount} ... tickets beyond active line<br/><br/>${maxClipboardDate} ... max date beyond`;
export const WARNING_DRAGGED_TICKETS_OFF_LEFT_SINGULAR = '< 1  more ticket';
export const WARNING_DRAGGED_TICKETS_OFF_LEFT_PLURAL = (count) => `< ${count} more tickets`;
export const WARNING_DRAGGED_TICKETS_OFF_RIGHT_SINGULAR = '1 more ticket >';
export const WARNING_DRAGGED_TICKETS_OFF_RIGHT_PLURAL = (count) => `${count} more tickets >`;

export const WARNING_NO_TICKETS_PASTED_BECAUSE_OF_ACCESS_RESTRICTIONS =
	"Can't paste any of the clipboard's tickets due to access restrictions";
export const WARNING_SOME_TICKETS_PASTED_EXCLUDED_OF_ACCESS_RESTRICTIONS = (excludedCount, totalCount) =>
	`Can\'t paste ${excludedCount} of the clipboard's ${totalCount} tickets due to access restrictions`;
export const WARNING_CANNOT_PASTE_TICKET_FROM_DIFFERENT_PROJECT =
	"Can't paste any of the clipboard's tickets because they are from another project";

// Clipboard's move-active-line guidelines:
export const CLIPBOARD_PASTE_TOP_GUIDE_TEXT = 'Top of Pasted Tickets';
export const CLIPBOARD_PASTE_BOTTOM_GUIDE_TEXT = 'Bottom of Pasted Tickets';

// Clipboard's move-active-line popup/calendar dialog:
export const PASTE_MOVE_ACTIVE_LINE_POPUP_HEADER = "Can't paste Exact Copy";
export const PASTE_MOVE_ACTIVE_LINE_POPUP_DESCRIPTION_LINE =
	'Some tickets in the clipboard have dates beyond the active line.';
export const PASTE_MOVE_ACTIVE_LINE_POPUP_MOVE_PREFIX = 'Move the active line to ';
export const PASTE_MOVE_ACTIVE_LINE_POPUP_MOVE_SUFFIX = 'then paste again.';
export const PASTE_MOVE_ACTIVE_LINE_POPUP_OK_LABEL = 'Move active line';
export const PASTE_MOVE_ACTIVE_LINE_POPUP_CANCEL_LABEL = 'Cancel';

// Popups
export const DEFAULT_POPUP_HEADING = 'Are you sure?';
export const DEFAULT_POPUP_SAVE_BUTTON = 'Save';
export const DEFAULT_POPUP_CANCEL_BUTTON = 'Cancel';

// Constraint acceptance panel
export const CONSTRAINT_ACCEPTANCE_PANEL_CUSTOMIZE_LABEL = 'Reassign';
export const CONSTRAINT_ACCEPTANCE_PANEL_JUMP_TO_PLAN_LABEL = 'Go to plan';
export const CONSTRAINT_ACCEPTANCE_PANEL_CLOSE_EDIT = 'Close ticket edit window to view constraint requests';

//multi ticket deletion
export const MULTI_TICKET_DELETE_TITLE = 'Are you sure you want to delete the selected tickets?';
export const MULTI_TICKET_DELETE_BUTTON_TEXT = 'Delete';

//multi-select menu
export const MULTI_SELECT_MENU = 'Multi-select menu';
export const MULTI_SELECT_MENU_DESC =
	'Perform actions on all selected tickets. To select or deselect all items in a swim lane, double-tap the swim lane label.';
export const MULTI_SELECT_MENU_EDIT_ALL = 'Edit all';
export const MULTI_SELECT_MENU_EDIT_LOCATIONS = 'Edit locations';
export const MULTI_SELECT_MENU_ALIGN_ROWS = 'Align rows';
export const MULTI_SELECT_MENU_COPY_TO_CLIPBOARD = 'Copy to clipboard';
export const MULTI_SELECT_MENU_DUPLICATE = 'Duplicate';
export const MULTI_SELECT_MENU_DELETE = 'Delete';
export const MULTI_SELECT_LOCKED_PLAN = 'Plan is locked';
export const CYCLE_TICKETS = 'Cycle tickets';
export const TAP_TICKET_BELOW_TO_EDIT = 'To edit, tap the ticket below';

// Ticket edit locations dialog
export const TICKET_EDIT_LOCATIONS_DIALOG_TEXT = 'Changes apply to all selected tickets';
export const TICKET_EDIT_DESCRIPTION = 'Description';
export const TICKET_EDIT_MILESTONE_EXTERNAL_SCHEDULE_ID = 'External Schedule ID';

//dependency deletion prompt
export const DEPENDENCY_DELETION_TITLE_DEFAULT = 'Delete dependencies?';
export const DEPENDENCY_DELETION_TITLE_TICKET_DELETION = 'Are you sure you want to delete these tickets?';
export const DEPENDENCY_DELETION_DESCRIPTION_TICKET_DELETION =
	'The selected tickets contain links to the below work items, milestones or constraints. These links will be removed.';
export const DEPENDENCY_DELETION_TITLE_PLAN_DELETION = 'To delete, remove links to the following plans:';
export const DEPENDENCY_DELETION_DESCRIPTION_PLAN_DELETION =
	'This plan contains work items, milestones, or constraints that have been linked to other plans. Remove dependencies between this plan and the following plans:';
export const TICKET_ERRORS_DURATION_TOO_LENGTHY_HEADER = 'Ticket duration is too long';
export const TICKET_ERRORS_DURATION_TOO_LENGTHY_MESSAGE =
	'Enter a number greater than 0 and up to 400 for Days';
export const TICKET_ERRORS_CREW_SIZE_TOO_LENGTHY_HEADER = 'Ticket crew size is too high';
export const TICKET_ERRORS_CREW_SIZE_TOO_LENGTHY_MESSAGE = 'Enter a number from 0 and up to 9999 for Crew';
export const TICKET_ERRORS_DURATION_WHOLE_HEADER = 'Ticket duration not valid';
export const TICKET_ERRORS_DURATION_WHOLE_MESSAGE = 'Enter a number greater than 0 and up to 400 for Days';
export const TICKET_ERRORS_CREW_SIZE_WHOLE_HEADER = 'Ticket crew size not valid';
export const TICKET_ERRORS_CREW_SIZE_WHOLE_MESSAGE = 'Enter a number greater than 0 and up to 400 for Days';
export const TICKET_ERRORS_REQUIRED_DATE_REQUESTED_HEADER = 'Need By Date is required';
export const TICKET_ERRORS_REQUIRED_DATE_REQUESTED_MESSAGE = 'Choose a need by date for the constraint';
export const TICKET_ERRORS_DESCRIPTION_REQUIRED_HEADER = 'Ticket description is required';
export const TICKET_ERRORS_DESCRIPTION_REQUIRED_MESSAGE = 'To save, add a description';
export const TICKET_ERRORS_DURATION_REQUIRED_HEADER = 'Ticket duration is required';
export const TICKET_ERRORS_DURATION_REQUIRED_MESSAGE = 'Enter a number greater than 0 and up to 400 for Days';
export const TICKET_ERRORS_CREW_REQUIRED_HEADER = 'Crew size is required';
export const TICKET_ERRORS_CREW_REQUIRED_MESSAGE = 'Enter a number from 0 and up to 9999 for Crew';
export const TICKET_ERRORS_ASSIGNED_TO_REQUIRED_HEADER = 'Project Member is required';
export const TICKET_ERRORS_ASSIGNED_TO_REQUIRED_MESSAGE = 'Assign this constraint to a project member';
export const TICKET_ERRORS_REQUESTED_BY_REQUIRED_HEADER = 'Project Member is required';
export const TICKET_ERRORS_REQUESTED_BY_REQUIRED_MESSAGE = 'Assign this constraint to a project member';
export const TICKET_ERRORS_LIVE_DATE_RANGE_MID_EDIT_HEADER = 'End Date is required';
export const TICKET_ERRORS_LIVE_DATE_RANGE_MID_EDIT_MESSAGE = 'To set End Date, tap the calendar';
export const TICKET_ERRORS_EDIT_INVALID_WHEN_ADDING = 'Correct errors before adding a new ticket';
export const TICKET_ERRORS_EDIT_INVALID_MORE_DETAILS = 'Correct errors before actualizing constraint';
export const TICKET_ERRORS_EDIT_INVALID_SWITCH_TICKET = 'Correct errors before switching tickets';

export const TICKET_SAVED_IMPLICITLY = 'Changes saved';

// New Edit Message Strings
export const EDIT_TOP_BAR_NEW_TICKET = 'Enter ticket details';
export const EDIT_TOP_BAR_TICKET_ERRORS = 'Address errors below';
export const EDIT_TOP_BAR_TICKET_ERRORS_TO_SAVE = 'To save, correct errors below';
export const EDIT_TOP_BAR_EDIT_TICKET = 'Revise ticket or tap "Update Status" to enter actual values';
export const EDIT_TOP_BAR_REVISE_TICKET_PULL_SIDE = 'Revise ticket details below';
export const EDIT_TOP_BAR_EDIT_TICKET_CONSTRAINT =
	'Revise ticket or tap "Update Status" to enter actual values';
export const EDIT_TOP_BAR_UPDATE_STATUS = 'Tap date to update actual start and end dates';
export const EDIT_TOP_BAR_UPDATE_STATUS_SPECIAL_TICKET = 'Select actual date';
export const EDIT_TOP_BAR_SELECTED_DATE = 'Select start and end date';
export const EDIT_TOP_BAR_SELECT_DATE_SINGLE = 'Select a date';
export const EDIT_TOP_BAR_VARIANCE_NEEDED = 'Specify variance reason';
export const EDIT_TOP_BAR_READ_ONLY = 'Read-only.';
export const EDIT_TOP_BAR_PLAN_LOCKED = 'Read-only. Tap "Update Status" to enter actual values.';
export const EDIT_TOP_BAR_PLAN_LOCKED_CONSTRAINT = 'Read-only. Tap "Update Status" to enter actual values.';
export const EDIT_TOP_BAR_ACTUALIZED = 'Completed ticket. Tap switch to view Planned / Actual values.';
export const EDIT_TOP_BAR_ACTUALIZED_CONSTRAINT =
	'Completed ticket. Tap switch to view Planned / Actual values.';
export const EDIT_TOP_BAR_VIEWING_PLANNED_PREVIEW =
	'Completed ticket. Tap switch to view Planned / Actual values.';
export const EDIT_TOP_BAR_CONSTRAINT_PENDING_ACCEPTANCE =
	'The assigned member needs to accept or re-assign this constraint';
export const EDIT_TOP_BAR_CONSTRAINT_ACCEPTED = 'Revise ticket or tap "Update Status" to enter actual values';
export const EDIT_TOP_BAR_READ_ONLY_SAMPLE_PROJECT_SHARED = 'Read-only';

export const QUICK_STATUS_UPDATE_TICKET_STATUS = 'Update Ticket Status';
export const QUICK_STATUS_COMPLETE_AS_PLANNED = 'Complete as planned';
export const QUICK_STATUS_COMPLETE_WITH_CHANGES = 'Complete with changes';
export const QUICK_STATUS_MARK_AS_STARTED = 'Start Work';
export const QUICK_STATUS_ERROR_PULL_TICKETS = 'Can only update scheduled tickets';
export const QUICK_STATUS_ERROR_NO_ACCESS = 'You can only update tickets in your role color';
export const QUICK_STATUS_ERROR_ACTUALIZED = "Can't update completed tickets";

export const EDIT_CONFIRM_ADD_AS_PREDECESSOR = 'Set as Predecessor';
export const EDIT_CONFIRM_REMOVE_AS_PREDECESSOR = 'Remove Predecessor';
export const EDIT_PLAN_LOCKED_WHILE_EDITING =
	'Plan is now locked, changes will not be saved. Contact a project admin to unlock the plan.';

export const PIN_HISTORY_DUPLICATE_DATES = 'Promise dates need to be unique';

export const WORKING_DAYS_END_DATE_IS_FIXED = 'End Date is fixed';
export const WORKING_DAYS_DURATION_FIXED = 'Workday count is fixed';

// GENERAL
export const GENERAL_OKAY = 'OK';
export const GENERAL_DONE = 'Done';
export const GENERAL_NEXT = 'Next';
export const GENERAL_MULTIPLE = 'Multiple';
export const GENERAL_NONE = 'None';
export const GENERAL_REQUIRED_FIELD = 'Required field';

// NOTIFIACTION MESSAGES
export const CENTER_ON_TICKET_MESSAGE = 'Centered on ticket';

//Variance
export const TICKET_VARIANCE_SUB_HEADER = 'Ticket end date changed. Choose a variance reason to continue.';
export const TICKET_VARIANCE_COMMENTS_PLACEHOLDER = 'Variance comment';

// text for use on UI controls, such as button and label text
export const UICONTROL_TEXT_SAVE = 'Save';
export const UICONTROL_TEXT_CANCEL = 'Cancel';
export const UICONTROL_TEXT_SEARCH = 'Search';
export const UICONTROL_TEXT_SEARCH_NO_ELLIPSIS = 'Search';
export const UICONTROL_TEXT_FULLVIEW = 'Full view';
export const UICONTROL_TEXT_SIDEVIEW = 'Side view';
export const UICONTROL_TEXT_GOBACK = 'Go back';
export const UICONTROL_TEXT_DATE = 'Date';
export const UICONTROL_TEXT_UNIQUE_DATE = 'Unique date';
export const UICONTROL_TEXT_OK = 'OK';
export const UICONTROL_TEXT_EDIT = 'Edit';
export const UICONTROL_TEXT_LOCK = 'Lock';
export const UICONTROL_TEXT_UNLOCK = 'Unlock';
export const UICONTROL_TEXT_COPY = 'Copy';
export const UICONTROL_TEXT_DELETE = 'Delete';
export const UICONTROL_TEXT_DISCARD = 'Discard';
export const UICONTROL_TEXT_LEARNMORE = 'Learn more';
export const UICONTROL_TEXT_CONTACTUS = 'Contact us';
export const UICONTROL_TEXT_NOT_SET = '<not set>';
export const UICONTROL_TEXT_INVALID_SELECTION = 'Invalid selection';
export const UICONTROL_TEXT_DISMISS = 'Dismiss';
export const UICONTROL_TEXT_DETAILS = 'Details';
export const UICONTROL_TEXT_CLOSE = 'Close';
export const UICONTROL_TEXT_UPLOAD = 'Upload';
export const UICONTROL_TEXT_REPLACE = 'Replace';
export const UICONTROL_TEXT_PROMISE_NOW = 'PROMISE NOW';
export const UICONTROL_PLUS_ONE_OTHER_SINGULAR = '(+ 1 other)';
export const UICONTROL_PLUS_N_OTHERS_PLURAL = (n) => `(+ ${n} others)`;

// member sapects
export const MEMBER_ASPECT_DASHBOARDS = 'Dashboards';
export const MEMBER_ASPECT_PROJECTS = 'Projects';
export const MEMBER_ASPECT_NOT_SELECTED = (name) => `No ${name} selected`;
export const MEMBER_ASPECT_CREATE_OR_SELECT_PROMPT = (name) => `Create a new ${name} or select from existing`;

// project property
export const PROJECT_PROPERTY_PROJECT = 'Project';
export const PROJECT_PROPERTY_COSTS = 'Cost';
export const PROJECT_PROPERTY_SCHEDULES = 'Schedule';
export const PROJECT_PROPERTY_PROJECT_NAME = 'Project name';
export const PROJECT_PROPERTY_PROJECT_LOGO = 'Project logo';
export const PROJECT_PROPERTY_PROJECT_LOGO_CHANGE = 'Change logo';
export const PROJECT_PROPERTY_PROJECT_ADDRESS = 'Street address';
export const PROJECT_PROPERTY_PROJECT_TYPE = 'Project type';
export const PROJECT_PROPERTY_PROJECT_CITY = 'City';
export const PROJECT_PROPERTY_PROJECT_TERRITORY = 'State/Province';
export const PROJECT_PROPERTY_PROJECT_POSTCODE = 'Zip/Postal code';
export const PROJECT_PROPERTY_PROJECT_TIME_ZONE = 'Time zone';
export const PROJECT_PROPERTY_PROJECT_COUNTRY = 'Country';
export const PROJECT_PROPERTY_PROJECT_ID = 'Project ID';
export const PROJECT_PROPERTY_LIFECYCLE = 'Lifecycle';
export const PROJECT_PROPERTY_BUILDING_OWNER = 'Building owner';
export const PROJECT_PROPERTY_MARKET_SECTOR = 'Market sector';
export const PROJECT_PROPERTY_NOTES = 'Notes';
export const PROJECT_PROPERTY_LATEST_VALUE = 'Latest value';
export const PROJECT_PROPERTY_VALUE_OVER_TIME = 'Value over time';
export const PROJECT_PROPERTY_VALUE_OVER_TIME_HELP = 'Latest in bold';
export const PROJECT_PROPERTY_TCD_LONG = 'Scheduled finish';
export const PROJECT_PROPERTY_TCD_SHORT = 'Scheduled';
export const PROJECT_PROPERTY_ECD_LONG = 'Estimated finish';
export const PROJECT_PROPERTY_ECD_SHORT = 'Estimated';
export const PROJECT_PROPERTY_SCHEDULE_DIFF_SHORT = 'Ahead/Behind';
export const PROJECT_PROPERTY_SCHEDULE_DIFF_LONG = 'Days difference';
export const PROJECT_PROPERTY_BAC_LONG = 'Budget at completion';
export const PROJECT_PROPERTY_BAC_SHORT = 'BAC';
export const PROJECT_PROPERTY_EAC_LONG = 'Estimate at completion';
export const PROJECT_PROPERTY_EAC_SHORT = 'EAC';
export const PROJECT_PROPERTY_COST_DIFF_SHORT = 'VAC';
export const PROJECT_PROPERTY_COST_DIFF_LONG = 'Variance at completion';
export const PROJECT_PROPERTY_DATE_ENTERED = 'Date entered';
export const PROJECT_PROPERTY_COMMENTS = 'Comments';
export const PROJECT_PROPERTY_UNIQUE_DATE_MESSAGE = (field) =>
	`Only unique date values are allowed for ${field} column. Select a different date.`;
export const PROJECT_PROPERTY_UNIQUE_DATE_TITLE = 'Unique date required';
export const PROJECT_ACTION_PROCORE = 'Log in to Procore';
export const PROJECT_ACTION_PROCORE_MISSING_PROCORE_PROJECT_ID =
	'Missing Procore project ID. Contact Touchplan Support.';
export const PROJECT_ACTION_PROJECT_INFORMATION = 'Project Information';
export const PROJECT_ACTION_REPORTS = 'Reports';
export const PROJECT_ACTION_MEMBERS = 'Members';
export const PROJECT_ACTION_ROLES = 'Roles';
export const PROJECT_ACTION_LOCATIONS = 'Locations';
export const PROJECT_LOGO_UPLOADED_SUCCESSFULLY = 'uploaded successfully';

export const PROJECT_DELETE_DELETE_PROJECT = 'DELETE PROJECT';
export const PROJECT_DELETE_CONFIRM_DELETE_PROJECT = 'Confirm delete project';
export const PROJECT_DELETE_DELETE_PROJECT_NOW = 'Delete project now';
export const PROJECT_DELETE_WAITING_MESSAGE = '... Waiting for backend to delete project ...';
export const PROJECT_DELETE_PROJECT_ID = (id) => `Project ID: ${id}`;
export const PROJECT_DELETE_PROJECT_CREATED_BY = (emailAddr) => `Created by: ${emailAddr}`;
export const PROJECT_DELETE_PROJECT_CREATED_TIMESTAMP = (timestamp) => `Created: ${timestamp}`;

// dashboard
export const DASHBOARD_DISPLAY_NAME = 'Insights';
export const DASHBOARD_LOADING_PROMPT = 'Loading dashboard ...';

//project cloning popup
export const PROJECT_CLONING_HEADER = 'Project copy';
export const PROJECT_CLONING_DESCRIPTION =
	'Clone a project from a template project, initializing with a set of project members from another project';

export const PROJECT_CLONING_PROJECT_NAME_HEADER = 'Project name';
export const PROJECT_CLONING_PROJECT_ADDRESS_HEADER = 'Project address';
export const PROJECT_CLONING_TEMPLATE_PROJECT_HEADER = 'Template project to copy from';
export const PROJECT_CLONING_SRC_PROJECT_HEADER = 'Project to copy project members from';
export const PROJECT_CLONING_OWNER_OVERRIDE_HEADER = 'Select an owner override, defaults to "you"';

// undo panel
export const UNDO_PANEL_HEADER = 'Undo changes';
export const UNDO_PANEL_DESC = 'Tap on the items below to undo/redo the actions performed';
export const UNDO_PANEL_MOST_RECENT_CHANGES = 'Most recent changes';
export const UNDO_PANEL_UNDO = 'UNDO';
export const UNDO_PANEL_REDO = 'REDO';
export const UNDO_PANEL_PREVIOUS_CHANGES = 'Previous changes';

// new projects page
export const PROJECT_LIST_TITLE = 'Projects';
export const PROJECT_LIST_SEARCH_PLACEHOLDER = 'Search';
export const PROJECT_LIST_ADD_PROJECT_LABEL = 'Project';
export const PROJECT_LIST_SHOW_ARCHIVE_LABEL = 'Show archived';

// copy project dialog
export const COPY_PROJECT_DIALOG_TITLE = 'Add project';
export const COPY_PROJECT_SOURCE_HEADER = 'Choose project source';
export const COPY_PROJECT_SOURCE_SUBTEXT = 'Project data will be copied from the project specified below';
export const COPY_PROJECT_RADIO_BUTTON_PROJECT_ID = 'Project ID';
export const COPY_PROJECT_RADIO_BUTTON_PROJECT_TEMPLATE = 'Project Template';
export const COPY_PROJECT_PROPERTY_PROJECT_NAME = 'Project name';
export const COPY_PROJECT_PROPERTY_PROJECT_TEMPLATE = 'Project template';
export const COPY_PROJECT_PROPERTY_PROJECT_ID = 'Project ID';
export const COPY_PROJECT_PROPERTY_COPIES = 'Copies';
export const COPY_PROJECT_MEMBERS_HEADER = 'Add members';
export const COPY_PROJECT_MEMBERS_SUBTEXT =
	'Additional members can be added to the project from a selected project';
export const COPY_PROJECT_PROPERTY_PROJECTS = 'Projects';
export const COPY_PROJECT_REMOVE_ME = 'Remove me after project is added';
export const COPY_PROJECT_PROPERTY_PROJECT_MEMBERS = 'Project Members';
export const COPY_PROJECT_OWNER_HEADER = 'Choose project owner';
export const COPY_PROJECT_OWNER_SUBTEXT =
	'Defaults to current user. If you add other members, you can select one as owner from the drop-down list below.';
export const COPY_PROJECT_PROPERTY_COPY_PROJECT_MEMBERS = 'Copy project members';
export const COPY_PROJECT_PROPERTY_SELECTED_MEMBERS = 'Selected members';
export const COPY_PROJECT_RADIO_BUTTON_OWNER_ID = 'Owner ID';
export const COPY_PROJECT_RADIO_BUTTON_PROJECT_MEMBERS = 'Project Members';
export const COPY_PROJECT_PROPERTY_PROJECT_OWNER_ID = 'Project Owner ID';
export const COPY_PROJECT_PROPERTY_PROJECT_OWNER = 'Project owner (defaults to you)';
export const COPY_PROJECT_SETTINGS_HEADER = 'New project settings';
export const COPY_PROJECT_SETTINGS_SUBTEXT = 'Name your new project(s) and enter the number of copies';
export const COPY_PROJECT_BUTTON_TEXT_COPY = 'ADD';
export const COPY_PROJECT_ERROR_MESSAGE = (name, message) => `Add Project error:  ${name}:  ${message}`;

// force refresh dialog
export const FORCE_REFRESH_DIALOG_TITLE = 'Touchplan upgrade needed';
export const FORCE_REFRESH_DIALOG_MESSAGE =
	'To continue working in Touchplan, click the button below.  Upgrading should take less than one minute.';
export const FORCE_REFRESH_DIALOG_BUTTON = 'REFRESH TO UPGRADE';

// project UI
export const PROJECT_ARCHIVED_LABEL = 'Archived';
export const PROJECT_NO_LOCATION_ENTERED_LABEL = 'No location entered';

// new plan page
export const PLAN_LIST_SEARCH_PLACEHOLDER = 'Search plans';
export const PLAN_LIST_ADD_PLAN_LABEL = 'Plan';
export const PLAN_LIST_SORT_CREATION_DATE = 'Creation date';
export const PLAN_LIST_SORT_PLAN_NAME = 'Plan name';
export const PLAN_LIST_STATUS_DAYS_BEHIND = (days) => `${days} days behind`;
export const PLAN_LIST_STATUS_DAYS_AHEAD = (days) => `${days} days ahead`;
export const PLAN_LIST_NO_MILESTONE_SET = 'No milestone set';
export const PLAN_LIST_CURRENT_PLAN_DATE = 'Current plan date';
export const PLAN_LIST_MILESTONE_DATE = 'Milestone date';

export const ADD_PLAN_TITLE = 'Add plan';
export const ADD_PLAN_WARNING_NAME_NOT_UNIQUE = 'New plan name needs to be unique';
export const EDIT_PLAN_WARNING_NAME_NOT_UNIQUE = 'Plan name needs to be unique';
export const EDIT_PLAN_TITLE = 'Edit plan';

// Pull plan ticket width sizes
export const NORMAL = 'Normal (Default)';
export const LARGE = 'Large';
export const EXTRA_LARGE = 'Extra Large';

export const COPY_PLAN_NAME_PATTERN = '{0} (copy)';
export const COPY_PLAN_ERROR_WITH_MESSAGE = (msg) => `Copy plan error:  ${msg}`;
export const COPY_PLAN_ERROR_WITH_NAME = (name) => `Could not copy plan, "${name}"`;

export const LOCATION_NAME_UNIQUE_TEXT = 'Location name needs to be unique';
export const USER_ALREADY_INVITED_TEXT = 'User is already invited to the project';
export const ROLE_NAME_UNIQUE_TEXT = 'Role name needs to be unique';
export const CUSTOM_FIELD_LABEL_UNIQUE_TEXT = 'Custom Field label name needs to be unique';
export const CUSTOM_FIELD_MAXIMUM_LIMIT_REACHED = (max) =>
	`Projects can have a maximum of ${max} custom fields`;
export const CUSTOM_FIELD_DROPDOWN_EDITOR_TITLE = 'Drop-down choices';
export const CUSTOM_FIELD_DROPDOWN_EDITOR_PLACEHOLDER = 'Choice';
export const CUSTOM_FIELD_VALIDATION_REQUIRED = (what) => `${what} value is required`;
export const CUSTOM_FIELD_VALIDATION_MAXIMUM = (what) => `Maximum ${what} characters`;
export const CUSTOM_FIELD_VALIDATION_ATLEASTONE = (what) => `Add at least one ${what}`;
export const CUSTOM_FIELD_VALIDATION_ATLEASTONEVISIBLE = (what) => `Add at least one visible ${what}`;
export const CUSTOM_FIELD_HINT_CANNOT_CHANGE = (what) => `Can\'t change ${what} after creation`;
export const CUSTOM_FIELD_INVALID_LINK = 'Link is invalid';
export const CUSTOM_FIELD_UNALLOWED_LINK = 'Link is not allowed by project admin';
export const USER_EXIST_DIALOG_TEXT = 'User is already a project member';
export const DELETE_DIALOG_TEXT = 'Are you sure?';
export const DELETE_DIALOG_YES = 'YES';
export const DELETE_DIALOG_NO = 'NO';
export const DELETE_PLAN_DIALOG_PLAN_DOES_NOT_EXIST = "Tried to delete plan that doesn't exist";

export const ADD_PROJECT_TITLE = 'Add a project';
export const ADD_PROJECT_MESSAGE = 'Chat with a Touchplan team member to get started:';

export const ADD_MEMBER_TITLE = 'Add member';
export const ADD_MEMBER_MESSAGE =
	'Sample projects are limited to a single member. Contact us to create a new project, then add the new members.';

export const PROJECT_ITEM_MEMBER_SINGULAR = 'Member';
export const PROJECT_ITEM_MEMBER_PLURAL = 'Members';
export const PROJECT_ITEM_ROLE_SINGULAR = 'Role';
export const PROJECT_ITEM_ROLE_PLURAL = 'Roles';
export const PROJECT_ITEM_LOCATION_SINGULAR = 'Location';
export const PROJECT_ITEM_LOCATION_PLURAL = 'Locations';
export const PROJECT_ITEM_SEARCH = (type) => `Search ${type}`;
export const PROJECT_MAST_COLOR_LIST_EDIT = (type) => `Edit ${type} colors`;
export const PROJECT_MEMBERS_ADMIN = 'Admin';
export const PROJECT_MEMBERS_ADMIN_OWNER = 'Admin (Owner)';
export const PROJECT_MEMBER_EMAIL_PLACEHOLDER = 'Email';
export const PROJECT_MEMBER_ROLES_PLACEHOLDER = 'Roles';
export const PROJECT_MEMBER_MEMBER_SECTION_TITLE = 'Signed up';
export const PROJECT_MEMBER_INVITED_SECTION_TITLE = 'Awaiting signup';
export const PROJECT_MEMBER_INVITED_SECTION_RESEND_BUTTON = 'Resend';
export const PROJECT_MEMBER_INVITED_SECTION_INVITATION_SENT = 'Invitation sent';
export const PROJECT_LOCATION_NAME_PLACEHOLDER = 'Location name';
export const PROJECT_ROLE_NAME_PLACEHOLDER = 'Role name';
export const PROJECT_LOCATION_COLOR_PLACEHOLDER = 'Color';
export const PROJECT_ROLE_COLOR_PLACEHOLDER = 'Color';
export const PROJECT_EMPTY_ITEM_MESSAGE = (type) => `Tap Add ${type} above to get started`;
export const PROJECT_EMPTY_ITEM_TITLE = (type) => `No ${type} on this project`;

export const PROMISE_NOW_CONFIRMATION_TITLE = 'Promise current period?';
export const PROMISE_NOW_CONFIRMATION_SUB_TITLE = 'You’re about to promise the current period. This action';
export const PROMISE_NOW_CONFIRMATION_SUB_TITLE2 = 'can’t be undone.';
export const PROMISE_NOW_CONFIRMATION_CANCEL = 'Cancel';
export const PROMISE_NOW_CONFIRMATION_PROMISE_NOW = 'Promise Now';

// Reload monitoring service
export const REFRESH_TO_UPGRADE = 'Refresh to upgrade';
export const NEW_VERSION_AVAILABLE = 'A new version of Touchplan is available';

export const NULL_STATE_LOOKERDOWNTIME = 'Insights temporarily unavailable';
export const NULL_STATE_COMINGSOON = 'Insights coming soon';
export const NULL_STATE_NOTCONFIGURED = 'Insights is not set up for your login';
export const NULL_STATE_NOPROJECT = 'No project selected';
export const NULL_STATE_CANNOTLOAD = 'Could not load Insights';
export const NULL_STATE_LOOKERDOWNTIME_MESSAGE =
	'It might be due to scheduled maintenance or other outage. Our team is aware of the problem and working to get service restored as soon as possible.';
export const NULL_STATE_NOPROJECT_MESSAGE = "Current user doesn't have access to Insights for this project";
export const NULL_STATE_TIMEOUT_MESSAGE =
	'Wait 10 seconds, then try refreshing your browser. If there`s still a problem, it might be due to scheduled maintenance or other outage.';
export const NULL_STATE_IFRAMEERROR_MESSAGE =
	'Try refreshing your browser. If there`s still a problem, it might be due to scheduled maintenance or other outage.';
export const NULL_STATE_APPMESSAGE_MESSAGE =
	'Insights temporarily unavailable due to scheduled maintenance or other outage';

export const CUSTOM_FIELD_DATA_TYPE_NUMBER = 'Number';
export const CUSTOM_FIELD_DATA_TYPE_LIST = 'Drop-down list';
export const CUSTOM_FIELD_DATA_TYPE_LINK = 'Link';
export const CUSTOM_FIELD_DATA_TYPE_TEXT = 'Text';
export const CUSTOM_FIELD_TICKET_TYPE_TASKS = 'Tasks';
export const CUSTOM_FIELD_TICKET_TYPE_MILESTONES = 'Milestones';
export const CUSTOM_FIELD_TICKET_TYPE_CONSTRAINTS = 'Constraints';
export const CUSTOM_FIELD_SHOW_ON_TICKET = 'Show on ticket form';
export const CUSTOM_FIELD_SHOW_ON_TICKET_FOR_ROLES = 'Show on tickets for these roles';
export const CUSTOM_FIELD_SELECT_ROLES_ALL = 'All';
export const CUSTOM_FIELD_SELECT_ROLES_NONE = 'None';
export const CUSTOM_FIELD_TAB_INFO = 'Info';
export const CUSTOM_FIELD_INFO_LABEL = 'Field label';
export const CUSTOM_FIELD_INFO_TYPE = 'Type';
export const CUSTOM_FIELD_INFO_UNIT = 'Units of measure';
export const CUSTOM_FIELD_INFO_TICKET_TYPES = 'Ticket types';
export const CUSTOM_FIELD_ALL_ROLES = 'All roles';
export const CUSTOM_FIELD_SINGULAR = 'Custom field';
export const CUSTOM_FIELD_PLURAL = 'Custom fields';
export const CUSTOM_FIELD_REQUIRED_CUSTOM_FIELD = 'Required custom field';
export const CUSTOM_FIELD_REQUIRED_CUSTOM_FIELDS_INFO = 'Required custom fields';

//fbdbRequest errors
export const FBDB_REQUEST_EMAIL_FAILED = 'Could not send invitation email. Try again later.';
export const FBDB_REQUEST_DISABLED = 'Requests are temporarily unavailable';

export const COLOR_PICKER_TITLE_LABEL = 'Choose a color from picker on right, then tap "Add color"';

//wbs
export const WBS_ACCEPTABLE_PHASE = 'Green';
export const WBS_DEMO_TABLE_NAME_1 = 'Sitework';
export const WBS_DEMO_TABLE_NAME_2 = 'Foundation - Bldg A';
export const WBS_DEMO_TABLE_NAME_3 = 'Structure - Bldg A';
export const WBS_DEMO_TABLE_HEADER_PHASE = 'TouchPlan Phase';
export const WBS_DEMO_TABLE_HEADER_NAME = 'WBS Name';
export const WBS_DEMO_TABLE_HEADER_START = 'Start';
export const WBS_DEMO_TABLE_HEADER_FINISH = 'Finish';
export const WBS_INSTRUCTIONS_STEP_1 =
	'In your master schedule, identify the phases you want to sync with Touchplan';
export const WBS_INSTRUCTIONS_STEP_2 =
	'Export the schedule data columns shown above from your master schedule to a .CSV (Comma-Separated Values) file. Make sure you include the header row.';
export const WBS_INSTRUCTIONS_STEP_3 = 'Upload the .CSV file to Touchplan, then tap';
export const WBS_INSTRUCTIONS_SYNC = 'SYNC WBS';
export const WBS_INSTRUCTIONS_LINK =
	'https://intercom.help/touchplanio/en/articles/1041949-schedule-integration';
export const WBS_INSTRUCTIONS_TEXT_PLACEHOLDER = 'Paste tab-separated schedule data here';
export const WBS_MENU_ITEM = 'Sync WBS';
export const WBS_CSV_FILE_CONTENT_INVALID = 'File format needs to be .CSV or tab-separated .TXT';
export const WBS_CSV_FILE_UPLOAD_PLACEHOLDER = 'WBS data file';
export const WBS_CSV_FILE_UPLOAD_SUCCESS = 'Data file uploaded successfully';
export const WBS_SYNC_SUCCESSFUL = 'WBS Sync successful';
export const WBS_SYNC_FAILED = 'WBS Sync failed.  Check your file format and try again.';

//file upload
export const FILE_UPLOAD_PLACEHOLDER = 'File selection';
export const FILE_UPLOAD_SUCCESS = 'File uploaded successfully';
export const FILE_UPLOAD_FAILURE = 'File upload failed';
export const FILE_UPLOAD_STARTUP = 'No file uploaded';
export const FILES_SELECTED = 'files selected';

// Number spinner
export const NUMBER_SPINNER_VALUE_IS_MISSING = (label) => `${label} is required`;
export const NUMBER_SPINNER_VALUE_IS_INVALID = (label) => `${label} value not valid`;
export const NUMBER_SPINNER_VALUE_IS_THE_MINIMUM = (min) => `${min} is the minimum`;
export const NUMBER_SPINNER_VALUE_IS_THE_MAXIMUM = (max) => `${max} is the maximum`;

//master schedule
export const PROJECT_SCHEDULE_TITLE = 'Scheduling';

// external schedule spreadsheet
export const EXTERNAL_SCHEDULE_SPREADSHEET_ERROR_MISSING_REQUIRED_SHEETS = 'Missing required sheet(s)';
export const EXTERNAL_SCHEDULE_SPREADSHEET_ERROR_MISSING_REQUIRED_COLUMNS = 'Missing required column(s)';
export const EXTERNAL_SCHEDULE_TITLE = 'External schedule';
export const EXTERNAL_SCHEDULE_INSTRUCTIONS_STEP_1 =
	'In your master schedule tool, set up your external schedule template with Touchplan columns, then export the template file';
export const EXTERNAL_SCHEDULE_INSTRUCTIONS_STEP_2 = 'Tap';
export const EXTERNAL_SCHEDULE_INSTRUCTIONS_STEP_3 =
	' (below) and choose the template file you exported in Step 1';
export const EXTERNAL_SCHEDULE_INSTRUCTIONS_STEP_4 =
	'To compare your Touchplan milestones to those in your master schedule, tap';
export const EXTERNAL_SCHEDULE_INSTRUCTIONS_STEP_5 =
	' (below) and then import the new file to your master schedule tool';
export const EXTERNAL_SCHEDULE_INSTRUCTIONS_STEP_6 =
	'If your master schedule changes, repeat the above steps';
export const EXTERNAL_SCHEDULE_UPLOAD_BUTTON_TEXT = 'Choose Template';
export const EXTERNAL_SCHEDULE_BUTTON_TEXT = 'Export Milestones';
export const EXTERNAL_SCHEDULE_DOWNLOAD_BUTTON_TEXT = 'Download';
export const EXTERNAL_SCHEDULE_EXPORTING_MESSAGE = 'Exporting Milestones';
export const EXTERNAL_SCHEDULE_EXPORTED_MESSAGE = (count) => `Exported ${count} Milestones`;
export const EXTERNAL_SCHEDULE_FILE_UPLOAD_PLACEHOLDER = `Schedule Template`;
export const EXTERNAL_SCHEDULE_FILE_UPLOAD_SUCCESS_MESSAGE = 'Template uploaded successfully';
export const EXTERNAL_SCHEDULE_FILE_UPLOAD_STARTUP_MESSAGE = 'No template uploaded';
export const EXTERNAL_SCHEDULE_FILE_UPLOAD_DEFAULT_ERROR_MESSAGE = 'File data format is not correct';
export const EXTERNAL_SCHEDULE_LINK =
	'https://intercom.help/touchplanio/en/articles/5108085-run-an-external-schedule-export';

// Ticket edit menu
export const TICKET_EDIT_VIEW_ATTACHMENTS = 'View attachments';
export const TICKET_EDIT_CAPTION = 'Caption';
export const TICKET_EDIT_ADD_PIN = 'Add pin';
export const TICKET_EDIT_REMOVE_PIN = 'Remove pin';
export const TICKET_EDIT_MORE_DETAILS = 'More details';
export const TICKET_EDIT_LINK_TO_PROCORE = 'Link to Procore';
export const TICKET_EDIT_PROCORE = 'Procore';
export const TICKET_EDIT_ADD_TO_TIMELINE = 'Add to timeline';
export const TICKET_EDIT_REMOVE_FROM_TIMELINE = 'Remove from timeline';
export const TICKET_EDIT_CHANGE_PRIMARY_ROLE = 'Change primary role';
export const TICKET_EDIT_CENTER_ON_TICKET = 'Center on ticket';
export const TICKET_EDIT_EDIT_ACTUAL_VALUES = 'Edit actual values';
export const TICKET_EDIT_REVERT_TO_PLANNED = 'Revert to planned';
export const TICKET_EDIT_RECLAIM_CONSTRAINT = 'Reclaim constraint';
export const TICKET_EDIT_SAVE_AND_DUPLICATE = 'Save & duplicate';
export const TICKET_EDIT_COPY_TO_CLIPBOARD = 'Copy to Clipboard';
export const TICKET_EDIT_DELETE = 'Delete';
export const TICKET_EDIT_CAN_ONLY_ATTACH_FILES_OF_SUPPORTED_TYPES = (types) =>
	`You can only attach files of type ${types}`;
export const TICKET_EDIT_CAN_ONLY_ATTACH_FILES_UP_TO_X_MB = (x) =>
	`You can only attach files smaller than ${x} MB`;

// file attachment
export const MAX_CHAR_ERROR_MESSAGE = 'Maximum 80 characters';
export const ATTACHMENT = 'Attachment';
export const ATTACHMENTS = 'Attachments';
export const TAP_TO_SELECT_ITEMS = 'Tap to select items';
export const SELECTED = 'selected';

//partitioning errors
//treat the isRepartitionInProgress flag showing up as an error
export const PARTITIONING_ERROR_REPARTITION_IN_PROGRESS = "Can't load project, a repartition is in progress";
//treat an index pointing to a projectCatalog that doesn’t exist as an error
export const PARTITIONING_ERROR_PROJECT_CATALOG_NOT_FOUND = "Can't load project, catalog entry not found";
//treat a project catalog pointing to a project that doesn’t exist as an error
export const PARTITIONING_ERROR_PROJECT_NOT_FOUND = "Can't load project, project entry not found";
export const PARTITIONING_ERROR_FIREBASE_PERMISSION = 'Permission denied';

// pull task ticket string warnings
export const ADJUST_PULL_TICKET_WIDTH_TITLE = 'Adjust pull tickets width';
export const CHANGES_TO_PULL_TASK_CONTENT_STRING_1 =
	'You can make your pull tickets wider to make more text visible during brainstorming sessions.';
export const CHANGES_TO_PULL_TASK_CONTENT_STRING_2 =
	'Note: Best used in a new, empty plan with no look-ahead tickets.';

// Docked Ticket
export const CONSTRAINT_DUE_DATE = 'Need By Date';
export const DATE = 'Date';
export const TIME = 'Time';
export const ACTUAL_START_DATE = 'Actual Start Date';
export const ACTUAL_START_TIME = 'Actual Start Time';
export const ACTUAL_FINISH_DATE = 'Actual Finish Date';
export const ACTUAL_FINISH_TIME = 'Actual Finish Time';
export const PLANNED_DATE = 'Planned Date';
export const PLANNED_START_DATE = 'Planned Start Date';
export const PLANNED_START_TIME = 'Planned Start Time';
export const PLANNED_FINISH_DATE = 'Planned Finish Date';
export const PLANNED_FINISH_TIME = 'Planned Finish Time';
export const PLAN_BY_DATE = 'Plan By Day';
export const PLAN_BY_TIME = 'Plan by Time/Hours';
export const NEED_BY_TIME = 'Need by Time/Hours';
export const PRIORITY = 'Priority';
export const CONSTRAINT_REQUESTED_BY = 'Requested By';
export const CONSTRAINT_ASSIGNED_TO = 'Assigned To';
export const START = 'Start';
export const START_TIME = 'Start Time';
export const START_ACTUAL = 'Start - Actual';
export const FINISH = 'Finish';
export const FINISH_TIME = 'Finish Time';
export const FINISH_ACTUAL = 'Finish - Actual';
export const DAYS = 'Days';
export const HOURS = 'Hours';
export const MINUTES = 'Minutes';
export const CREW = 'Crew';
export const WORKDAYS = 'Workdays';
export const VARIANCE_REASON = 'Variance Reason';
export const SHOW_CUSTOM_FIELDS = 'Show Custom Fields';
export const WORK_SCHEDULE = 'Work Schedule';
export const RESET_ALL = 'Reset All';
export const CLEAR = 'Clear';
export const DURATION_MAX = 'Duration must be less than 9600 hours';
export const DURATION_MIN = 'Duration must be greater than 0';
export const INVALID_HOURS = 'Hours must be between 0 and 9600';
export const INVALID_MINUTES = 'Minutes must be between 0 and 576000';

export const NON_WORKDAYS = (dates) => `Selected non-workdays: ${dates}`;

export const INTERNAL_ERROR_WARNING = (projectId) =>
	`Touchplan needs access to https://us-central1-${projectId}.cloudfunctions.net/ to perform this action, but your computer or network settings are blocking that site. Adjust your firewall settings or contact your IT department to allow access.`;
export const CREATE_ACCOUNT_ERROR_TITLE = 'Cannot create account';

export const EXTERNAL_LINK_SETTINGS = 'External link settings';
export const EXTERNAL_LINK_MODAL_CONTENT =
	'Enter allowed websites for link custom fields. Separate each sites using commas.';
export const MISSING_FIELDS_WARNING_MESSAGE =
	"You can't save your changes yet. Please fill in all fields marked in red, across all tabs, to save your changes.";

// Organization editor
export const ORG_CRED_DIALOG_TITLE = 'Client ID and secret';
export const ORG_CRED_DIALOG_LINES = (applicationName) => [
	`Here are the credentials for "${applicationName}".`,
	'',
	'Save the client secret somewhere safe - if you lose it you will',
	'have to generate a new one.',
];
export const ORG_EDITOR_GENERATE_NEW_SECRET = 'Generate new secret';
export const ORG_EDITOR_APPLICATION_NAME = 'Application name';
export const ORG_EDITOR_APPLICATION_DESCRIPTION = 'Application description';
export const ORG_EDITOR_MAIN_WEBSITE_ADDRESS = 'Main website address';
export const ORG_EDITOR_CLIENT_ID = 'Client ID';

export const ORG_EDITOR_TITLE = API_SETTINGS;
export const ORG_EDITOR_ADD_APPLICATION = 'Application';
export const ORG_EDITOR_NO_APPLICATIONS = 'No applications added';
export const ORG_EDITOR_NO_APPLICATIONS_DESC = 'Click Add Application above to get started';
export const ORG_TAB_INFO = CUSTOM_FIELD_TAB_INFO;
export const ORG_TAB_PROJECTS = 'Projects';

// Plan Archived
export const PLAN_ARCHIVED_PREFIX = '<Archived>';
//-------------------------------------------------- END OF STRING CONSTANTS COMING FROM COMMON FILE --------------------------------------------------

//-------------------------------------------------- START OF STRING CONSTANTS COMING FROM FRONTEND FILE --------------------------------------------------
// nav bar menu
export const SUPPORT_MENU_HELP_CENTER = 'Help Center';
export const SUPPORT_MENU_ADMIN_USER_RESOURCES = 'Admin User Resources';
export const SUPPORT_MENU_BASIC_USER_RESOURCES = 'Basic User Resources';
export const CHANGE_ROLE_TO = 'Change Role To';
export const OVERVIEW_MENU = 'Overview';

//General warnings
/** Warning displayed when trying to load into a plan you don't have access to or doesn't exist. */
export const PROJECT_ACCESS_OUT_OF_DATE_DATA =
	'Error, the user does not have access to the project or the data is out of date.';
export const PLAN_ACCESS_ON_LOAD =
	"You don't have plan access or plan doesn't exist. Returning to Project's plan list.";
export const TIMELINE_TICKETS_PLAN_TICKET_RESTRICTED = 'The plan the ticket is on is restricted';
export const TIMELINE_TICKETS_CURRENT_PLAN_RESTRICTED = 'The current plan is restricted';
export const TIMELINE_TICKETS_ONLY_ADMINS_CAN_MODIFY_ACCESS = 'Only admins can modify access';
//Drag to Drafts (f.k.a. floating space, etc.)

/** displayed when trying to drag a started ticket into the floating space */
export const DRAG_STARTED_INTO_FLOATING = `Can\'t move started tickets to Drafts`;

/** displayed when dragging id-conflicting tickets from drafts to the plan surface */
export const NO_TICKETS_FOUND = 'No tickets found';

//Common Dialogs
export const UNSAVED_CHANGES_GUARD_DIALOG_TITLE = 'You have unsaved changes.';
export const UNSAVED_CHANGES_GUARD_DIALOG_YES_BUTTON = 'Stay on Page';
export const UNSAVED_CHANGES_GUARD_DIALOG_NO_BUTTON = 'Leave Page';

/**
 * Advanced Settings panel - enable dependency text
 */
export const ENABLE_DEPENDENCY_TEXT_LABEL = 'Enable Dependency Text';
/**
 * Advanced Settings panel - Enable Modern Timeline
 */
export const USE_MODERN_TIMELINE_TEXT_LANE = `Enable Modern Timeline`;

/**
 * ACCESS JOIN
 */
export const ACCESS_CODE_ENTER_CODE_TITLE_CASE = 'Have an access code?';

/**
 * CREW SIZES
 */
export const CREW_DEFAULT_CREW_SIZE_TITLE = 'Default crew size';
export const CREW_DEFAULT_CREW_SIZE_MENU_DESCRIPTION = 'Configure default crew size';

export const PROCORE_CREATE_NEW = 'Create New';

export const TICKET_EDIT_MULTIPLE_EXTERNAL_SCHEDULE_ID = 'Multiple External Schedule ID';

// Ticket edit wbs code
export const TICKET_EDIT_MULTIPLE_WBS_CODE_LABEL = 'Multiple WBS Codes';

//dependency deletion prompt
export const DEPENDENCY_DELETION_BUTTON_CANCEL = 'Cancel';
export const DEPENDENCY_DELETION_BUTTON_DELETE = 'Delete';
export const DEPENDENCY_DELETION_BUTTON_CLOSE = 'Close';

export const TICKET_ERRORS_DURATION_MIN_MAX_MESSAGE = (min, max) =>
	`Enter a number between ${min} and ${max} (inclusive) for Days`;
export const TICKET_ERRORS_CREW_SIZE_MIN_MAX_MESSAGE = (min, max) =>
	`Enter a number between ${min} and ${max} (inclusive) for Crew`;

export const TICKET_ERRORS_EDIT_INVALID_WHEN_ADDING_WITH_NO_ROLE =
	'A role is required to create new tickets.';

// dependency deletion dialog
export const DEPENDENCY_DELETION_PLAN_NAME = 'Plan Name';
export const DEPENDENCY_DELETION_TICKET_NAME = 'Ticket Name';

// New Edit Message Strings
export const EDIT_CONFIRM_EDIT_PREDECESSOR = 'Edit Predecessor';

export const GENERAL_FIX_ALL_ERRORS = 'All Errors must be resolved';

// Multiple values
export const GENERAL_MULTIPLE_VALUES = 'Multiple Values';
export const GENERAL_MULTIPLE_LOCATIONS = 'Multiple Locations';
export const GENERAL_MULTIPLE_ROLES = 'Multiple Roles';
export const GENERAL_MULTIPLE_REQUESTED_BY = 'Multiple Requesters';
export const GENERAL_MULTIPLE_ASSIGNED_TO = 'Multiple Assignees';
export const GENERAL_MULTIPLE_DESCRIPTIONS = 'Multiple Descriptions';
export const GENERAL_MULTIPLE_MILESTONE_TYPE = 'Multiple Milestone Types';
export const GENERAL_MULTIPLE_CREW = 'Multiple Crew';
export const GENERAL_MULTIPLE_DAYS = 'Multiple Duration Days';
export const GENERAL_MULTIPLE_NEED_BY_DATES = 'Multiple Need by Dates';
export const GENERAL_UNAUTHENTICATED_USER = 'Unauthenticated user, please authenticate';

export const TICKET_PLACEHOLDER_LOCATION = 'Location';
export const TICKET_PLACEHOLDER_ROLE = 'Role';

// NOTIFICATION MESSAGES
export const UNABLE_TO_PERFORM_ACTION_BECAUSE_PLAN_ACCESS = (action, planAccess) =>
	`You can't ${action} because this plan is ${planAccess}.`;
export const UNABLE_TO_PERFORM_ACTION_BECAUSE_NOT_ADMIN = (action) =>
	`You can't ${action} because you are not an admin.`;
export const UNABLE_TO_PERFORM_ACTION_BECAUSE_NEED_TO_CREATE_MILESTONE = (action) =>
	`You can't ${action} because you need to create a milestone.`;
export const UNABLE_TO_PERFORM_ACTION_BECAUSE_NEED_TO_ACTIVATE_YOUR_PULL_COLUMN = (action) =>
	`You can't ${action} because you need to activate your pull column.`;

export const UICONTROL_TEXT_NEXT = 'Next';
export const UICONTROL_TEXT_BACK = 'Back';
export const UICONTROL_TEXT_ADD_NEW = 'Add New';
export const UICONTROL_TEXT_CLEAR_SETTINGS = 'Clear Settings';
export const UICONTROL_TEXT_START_DATE = 'Start date';
export const UICONTROL_TEXT_END_DATE = 'End date';
export const UICONTROL_TEXT_COMPLETED = 'Completed';
export const UICONTROL_TEXT_STARTED = 'Started';
export const UICONTROL_TEXT_TODO = 'Todo';

export const PROJECT_PROPERTY_MASTER_SCHEDULE = 'Master Schedule';
export const PROJECT_PROPERTY_REPORT_LOGO = 'Report logo';
export const PROJECT_PROPERTY_PROJECT_LOGO_SIZE = 'Rec: 148x148';
export const PROJECT_PROPERTY_REPORT_LOGO_SIZE = 'Rec: 200x40';
export const PROJECT_PROPERTY_ORGANIZATION = 'Organization';

export const PROJECT_ACTION_SWIMLANES = 'Swimlanes';
export const PROJECT_ORGANIZATION_NOT_VISIBLE = 'Only visible for org admins';
export const PROJECT_ACTION_SHOW_INSIGHTS = 'Show insights';
export const PROJECT_ACTION_PROJECT_SETTINGS = 'Project Settings';

export const COPY_CHOOSE_PARENT_ORG_HEADER = 'Choose parent organization';
export const COPY_CHOOSE_PARENT_ORG_SUBTEXT = 'Link added projects with other projects in same organization';
export const COPY_CHOOSE_PARENT_ORG_PLACE_HOLDER = 'Parent organization';
export const COPY_PROJECT_PROPERTY_COPY_ARCHIVED_PLANS = 'Copy archived plans';
export const COPY_PROJECT_PROPERTY_COPIES_SUBTEXT = 'You can select up to 20 copies';

export const FORCE_REFRESH_LOADING = 'Applying update';

export const PLAN_LIST_SHOW_ARCHIVE_LABEL = 'Show archived';

// Edit Plan Dialog
export const EDIT_PLAN_DIALOG_TEXT_PLAN_NAME = 'Plan Name';
export const EDIT_PLAN_DIALOG_TEXT_ARCHIVE = 'Archive';
export const EDIT_PLAN_DIALOG_TEXT_INCLUDE_IN_ANALYTICS = 'Include in analytics';
export const EDIT_PLAN_DIALOG_TEXT_USE_PLAN_START_DATE = "Use this plan's Start Date";
export const EDIT_PLAN_DIALOG_TEXT_USE_PLAN_START_DATE_TOOLTIP =
	'Week 1 aligns with the Monday on or before your Start Date';

export const PROJECT_MEMBER_PRIMARY_ROLE_PLACEHOLDER = 'Primary Role';
export const PROJECT_MEMBER_ASSIGNED_ROLES_PLACEHOLDER = 'Assigned Roles';
export const PROJECT_SELECT_COLOR = 'Select Color';
export const PROJECT_MEMBER_EMAIL_INVALID = 'Invalid email';
export const PROJECT_MEMBER_EMAIL_EXISTS_ERROR = 'Project member with this email already exists';

export const NULL_STATE_BASIC_USER = 'Select a project from your list to continue';

export const CUSTOM_FIELD_SHOW_ON_HIDDEN_TICKET = 'Show hidden custom fields';

//fbdbRequest errors
export const FBDB_ERROR_TIMEOUT = 'The request timed out';

//wbs
export const WBS_CODE = 'WBS Code';

export const TICKET_EDIT_START_WORK = 'Start work';

// hover-over plan action
export const PLAN_ACTION_ENABLE_HOVER_OVER = 'Enable hover-over';
export const PLAN_ACTION_DISABLE_HOVER_OVER = 'Disable hover-over';

// hover-over actions
export const HOVER_OVER_ACTION_EDIT_FIELDS = 'Edit fields';
export const HOVER_OVER_ACTION_DISABLE = 'Disable hover';

// Docked Ticket
export const ENTER_VALID_DATE_ERR = 'Enter date as month/day/year';
export const CONSTRAINT_LOCATION = 'Location';
export const DATE_ACTUAL = 'Date - Actual';

export const TOOLTIP_CONTENT_SETTINGS = 'Hover over content settings';
export const TOOLTIP_CONTENT_MODAL_CONTENT = 'Select fields to display on ticket hover over';
export const TOOLTIP_CONTENT_OPTION_DESCRIPTION = 'Description';
export const TOOLTIP_CONTENT_OPTION_ROLE = 'Role';
export const TOOLTIP_CONTENT_OPTION_LOCATION = 'Location';
export const TOOLTIP_CONTENT_OPTION_DURATION = 'Duration';
export const TOOLTIP_CONTENT_OPTION_CREW = 'Crew';
export const TOOLTIP_CONTENT_OPTION_ATTACHMENTS_NUMBER = 'Number of attachments';
export const TOOLTIP_CONTENT_OPTION_NEED_BY_DATE = 'Need by date';
export const TOOLTIP_CONTENT_OPTION_ASSIGN_TO = 'Assigned To';
export const TOOLTIP_CONTENT_SETTINGS_CUSTOM_FIELDS_RADIO_ALL = 'All Custom Fields';
export const TOOLTIP_CONTENT_SETTINGS_CUSTOM_FIELDS_RADIO_SELECT = 'Selected Custom Fields';

// Organization editor
export const ORG_EDITOR_NAME_NOT_SET = '<name not set>';
export const ORG_TEXT_DESCRIPTION = 'Enable this application for';

// Organization Disclaimer
export const ORG_DISCLAIMER_TEXT =
	'Touchplan is a web based coordination and planning platform. Touchplan is not the contractual Project Schedule. Utilization of Touchplan and representations/information contained herein does not modify the contractual Project Schedule, change any contractual requirements or relieve any party from following the terms of their Contract.';
export const ORG_DISCLAIMER_ACCEPT_BUTTON = 'Accept';

// Ticket import
export const IMPORT_TICKETS = 'Import Tickets';
export const IMPORT_TICKETS_VALIDATE_STEP_TITLE = 'Validate';
export const IMPORT_TICKETS_INSERTION_POINT_STEP_TITLE = 'Insertion Point';
export const IMPORT_TICKETS_RESOLVE_ESID_TITLE = 'Resolve matching tickets';
export const IMPORT_TICKETS_FILE_PLACEHOLDER = 'Tickets data file';
export const IMPORT_TICKETS_FILE_UPLOAD_SUCCESS = 'Tickets data file uploaded successfully';
export const IMPORT_TICKETS_FILE_UPLOAD_ERROR = 'Unable to upload ticket data file';
export const DOWNLOAD_BLANK_SAMPLE_BUTTON = 'Download blank sample';
export const DOWNLOAD_BLANK_SAMPLE_FILE_TEXT = 'Download the blank sample file by clicking the button above';
export const OPEN_FILE_INSTRUCTION_TEXT =
	'Open the file and enter or edit your ticket information, then save the file';
export const IMPORT_TICKETS_INSTRUCTION_TEXT_PART_1 = 'Click ';
export const IMPORT_TICKETS_INSTRUCTION_TEXT_PART_3 = ' button below, then choose your file to import';
export const NEWLY_ADDED_TICKETS_APPEAR_INSTRUCTION_TEXT =
	'Newly added tickets will appear on a new plan named';
export const IMPORT_TICKETS_SUCCESS_TITLE = 'Ticket import succeeded';
export const IMPORT_TICKETS_PLAN_NAME = (todaysDateTime) => `Imported Tickets ${todaysDateTime}`;
export const IMPORT_TICKETS_SUCCESS_MESSAGE = (planName: string) => [
	`You can find the tickets on a new plan named`,
	`"${planName}"`,
];
export const IMPORT_TICKETS_FAIL_TITLE = 'Ticket import failed';
export const IMPORT_TICKETS_ERROR_MESSAGE = [
	'Click the Download Errors button bellow',
	'to view the error file. Fix errors and try',
	'again.',
];
export const IMPORT_TICKETS_DOWNLOAD_ERROR_BUTTON = 'Download Errors';
export const IMPORT_TICKETS_DOWNLOAD_SAMPLE_BUTTON = 'Download Sample';
export const IMPORT_TICKETS_ERROR_MESSAGE_UPLOAD_CORRECT_FILE =
	'Upload a Touchplan import file in .XLSX format to import tickets.';
export const IMPORT_TICKETS_ERROR_MESSAGE_DO_NOT_REMOVE_COLUMN_NAMES_AND_TABS =
	'Do not change or remove any of the column names or worksheet tabs.';
export const IMPORT_TICKET_ERROR_SIZE = 'Excel row count greater than 4000.';
export const IMPORT_TICKET_ERROR_SIZE_2 = 'Try reducing the number of rows in the Excel file and try again.';
export const IMPORT_TICKETS_BUTTON_TEXT = 'Select File';
export const IMPORT_TICKETS_TEMPLATE_INVALID_FORMAT = 'Invalid format, must be .xlsx';
// Import Tickets V2
export const IMPORT_TICKET_PLAN_SELECT_PLACEHOLDER = 'Plan';
export const IMPORT_TICKET_PLAN_SELECT_NO_TEXT = 'All Plans';
export const IMPORT_TICKET_PLAN_SELECT_ERROR = 'Please select a plan before proceeding.';
export const IMPORT_TICKET_PLAN_DESTINATION_WARNING = (planName) =>
	`There is no active space on the plan '${planName}'.  Only pull tickets will be imported into this plan.  Active space tickets can be imported after the active line is expanded.`;
export const IMPORT_TICKET_FILE_UPLOAD_TEXT = 'Upload tickets data file in the selected format.';
export const IMPORT_TICKET_FILE_TO_CREATE_TEXT = 'To create a new data file in the Touchplan format,';
export const IMPORT_TICKET_DEFAULT_ROLE_TEXT_R1 =
	'Any row in the data file without a role will be assigned the Default role';
export const IMPORT_TICKET_DEFAULT_ROLE_TEXT_R2 = 'Specify the import behavior';
export const IMPORT_BEHAVIOR_TITLE = 'Import behavior';
export const IMPORT_BEHAVIOR_DESCRIPTION =
	'Configure the import behavior to control whether tickets are created or updated';
export const IMPORT_BEHAVIOR_OPTION_CREATE_ONLY_NEW_TICKETS_TITLE = 'Create only new tickets';
export const IMPORT_BEHAVIOR_OPTION_CREATE_ONLY_NEW_TICKETS_DESCRIPTION =
	'creates new tickets in the plan, but only if there are no other tickets in the plan with matching External Schedule IDs. It will not update any existing tickets in the plan';
export const IMPORT_BEHAVIOR_OPTION_CREATE_WITH_DUPLICATES_TITLE = 'Create with duplicates';
export const IMPORT_BEHAVIOR_OPTION_CREATE_WITH_DUPLICATES_DESCRIPTION =
	'creates one new ticket for each row of ticket data in the import file. It will create tickets with External Schedule IDs that are duplicates of tickets already in the plan. It will not update any existing tickets in the plan.';
export const IMPORT_BEHAVIOR_OPTION_UPDATE_ONLY_TITLE = 'Update only';
export const IMPORT_BEHAVIOR_OPTION_UPDATE_ONLY_DESCRIPTION =
	'updates tickets on the plan whose External Schedule ID match the ticket identifier in the import file. This mode does not create new tickets. If multiple tickets on the plan match a row in the input file you can choose which get updated.';
export const IMPORT_BEHAVIOR_OPTION_CREATE_AND_UPDATE_TITLE = 'Create and update';
export const IMPORT_BEHAVIOR_OPTION_CREATE_AND_UPDATE_DESCRIPTION =
	'both creates new tickets and updates existing tickets on the plan. If a ticket on the plan has an External Schedule ID matching a row in the import file it will be updated, otherwise a new ticket will be created.';
export const IMPORT_TICKET_SWIMLANE_PLACEMENT_FIELD_LABEL = 'Swimlane Placement';
export const IMPORT_TICKET_SWIMLANE_WBS_LEVEL_LABEL = 'WBS Swimlane Level';
export const IMPORT_TICKET_SWIMLANE_PLACEMENT_TEXT =
	'Tickets are placed in swimlanes on the plan. If no matching swimlane exists on the plan, one will be created. If an update mode is selected, updated tickets will be moved to a matching swimlane.';
export const SWIMLANE_PLACEMENT_TITLE = 'Swimlane placement';
export const SWIMLANE_PLACEMENT_DESCRIPTION =
	'Touchplan can automatically place tickets in swimlanes, creating swimlanes if they do not already exist in the plan. When updating existing tickets on the plan, those tickets will be moved into swimlanes.';
export const SWIMLANE_PLACEMENT_FACTORS_TITLE = 'The tickets can be placed based on the following factors:';
export const SWIMLANE_PLACEMENT_FACTOR_ROLE_TITLE = 'Role:';
export const SWIMLANE_PLACEMENT_FACTOR_ROLE_DESCRIPTION =
	'Tickets will be placed in swimlanes based on their role';
export const SWIMLANE_PLACEMENT_FACTOR_LOCATION_TITLE = 'Location:';
export const SWIMLANE_PLACEMENT_FACTOR_LOCATION_DESCRIPTION =
	'Tickets will be placed in swimlanes based on their location';
export const SWIMLANE_PLACEMENT_FACTOR_WBS_TITLE = 'WBS:';
export const SWIMLANE_PLACEMENT_FACTOR_WBS_DESCRIPTION =
	'Tickets will be placed in swimlanes based on their WBS code and the selected WBS swimlane level.';
export const IMPORT_TICKET_ADVANCE_ACTIVE_LINE_TOGGLE_TITLE = 'Advance active line';
export const IMPORT_TICKET_PRESERVE_PULL_TICKETS_TOGGLE_TITLE = 'Preserve pull tickets';
export const IMPORT_TICKET_TOGGLES_TEXT =
	'If the active line is not advanced, tickets may be created in pull space';
export const IMPORT_TICKET_PRESERVE_PULL_TICKETS_TITLE = 'Pull Tickets and the active line';
export const IMPORT_TICKET_PRESERVE_PULL_TICKETS_TOGGLE_DESCRIPTION_1 =
	'Preserving pull tickets keeps keeps them to the right of the active line as the active line is moved. This is how moving the active line using the calendar works.';
export const IMPORT_TICKET_PRESERVE_PULL_TICKETS_TOGGLE_DESCRIPTION_2 =
	'If pull tickets are not preserved they will remain in place as the active line moves. This is how moving the active line by dragging with the mouse works.';
export const IMPORT_TICKET_PRESERVE_PULL_TICKETS_WARNING_DESCRIPTION =
	'If "Advance active line" is not selected, any tickets in the import file with dates after the active line date will not be imported. They will be identified with WARNING on the ticket import result file.';
export const IMPORT_TICKET_STEP_1_FOOTER_TEXT =
	'The next step will lock the plan. It will unlock when the import process ends.';
// import type select
export const IMPORT_TICKET_IMPORT_TYPE_CREATE_ONLY = 'Create only new tickets';
export const IMPORT_TICKET_IMPORT_TYPE_CREATE_DUPLICATES = 'Create with duplicates';
export const IMPORT_TICKET_IMPORT_TYPE_UPDATE_ONLY = 'Update only';
export const IMPORT_TICKET_IMPORT_TYPE_CREATE_UPDATE = 'Create and update';
//file format select
export const IMPORT_TICKET_FORMAT_TOUCHPLAN = 'Touchplan';
export const IMPORT_TICKET_FORMAT_P6 = 'P6 Excel';
//swimlane placement select
export const IMPORT_TICKET_SWIMLANE_PLACEMENT_NONE = 'No swimlane placement';
export const IMPORT_TICKET_SWIMLANE_PLACEMENT_WBS = 'WBS';
export const IMPORT_TICKET_SWIMLANE_PLACEMENT_LOCATION = 'Location';
export const IMPORT_TICKET_SWIMLANE_PLACEMENT_ROLE = 'Role';
// import scope select
export const IMPORT_TICKET_SCOPE_PLACEHOLDER = 'Import Scope';
export const IMPORT_TICKET_SCOPE_TEXT = 'Specify what should be included in this import.';
export const IMPORT_TICKET_SCOPE_TICKETS = 'Tickets';
export const IMPORT_TICKET_SCOPE_PREDECESSORS = 'Predecessors';

export const IMPORT_TICKET_VALIDATION_STEP_TITLE = 'Validation Results';
export const IMPORT_TICKET_VALIDATION_STEP_ERROR_TEXT = (errorCount) => `${errorCount} Errors`;
export const IMPORT_TICKET_VALIDATION_STEP_WARNING_TEXT = (warningCount) => `${warningCount} Warnings`;
export const IMPORT_TICKET_VALIDATION_STEP_INDICATION_1 =
	'Download the validation result file and fix the errors identified in the Errors column.';
export const IMPORT_TICKET_VALIDATION_STEP_INDICATION_2 = 'Upload the fixed file below.';
export const IMPORT_TICKET_VALIDATION_STEP_MISSING_COLUMNS_TITLE = 'Validation failed';
export const IMPORT_TICKET_VALIDATION_STEP_MISSING_COLUMNS_ERROR_TEXT =
	'An error ocurred processing your request:';
export const IMPORT_TICKET_VALIDATION_STEP_MISSING_COLUMNS_INDICATION_1 =
	'Download the validation result file and fix the errors.';
export const IMPORT_TICKET_VALIDATION_STEP_MISSING_COLUMNS_INDICATION_2 = 'Upload the fixed file below.';
export const IMPORT_TICKET_VALIDATION_STEP_WARNING_VERBIAGE =
	'Warnings will not prevent the import from completing, however results may not be as intended';
export const IMPORT_TICKET_VALIDATION_STEP_DOWNLOAD_ERRORS_BUTTON = 'Download Errors';
export const IMPORT_TICKET_VALIDATION_STEP_DOWNLOAD_WARNINGS_BUTTON = 'Download Warnings';
export const IMPORT_TICKET_INSERTION_POINT_STEP_TEXT =
	'Drag the insertion point for imported tickets. Tickets and swimlanes on plan will be moved to accommodate imported tickets.';
export const IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_TITLE = 'Variance Reasons';
export const IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_INSTRUCTIONS =
	'The following tickets are pinned and must either have variance reasons assigned or be marked as skipped to exclude them from the import. Use the checkboxes to select tickets and choose to skip or select the variance reason and click APPLY to set all checked tickets';
export const IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_MODE_SELECT_ASSIGN = 'Assign variance';
export const IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_MODE_SELECT_EXCLUDE = 'Exclude dates from update';
export const IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_VARIANCE_REASON_LABEL = 'Variance Reason';
export const IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_VARIANCE_COMMENT_LABEL = 'Variance Comment';
export const IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_APPLY_BUTTON = 'APPLY';
export const IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_SELECT_ALL_LABEL = 'Select all unresolved tickets';
export const IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_SWIMLANE_LABEL = 'Swimlane';
export const IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_NEXT_LABEL = 'FINISH IMPORT';
export const IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_PROCESSING_REQUIREMENTS_TITLE =
	'Import cannot be processed';
export const IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_PROCESSING_REQUIREMENTS =
	'The import cannot be processed until all tickets have variance reasons assigned or are excluded from date updates';
export const IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_UPDATING_PROMISED_TICKET_INSTRUCTIONS =
	'Updating promised ticket through Ticket Import';
export const IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_VARIANCE_REASON_REQUIRED =
	'Variance reasons are required to set planned or actual dates that differ from the pinned dates on tickets.';
export const IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_ASSIGN_VARIANCE_REASON_INSTRUCTIONS_LINE_1 =
	'To assign variance reasons:';
export const IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_ASSIGN_VARIANCE_REASON_INSTRUCTIONS_LINE_2 =
	'Select the variance reason';
export const IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_ASSIGN_VARIANCE_REASON_INSTRUCTIONS_LINE_3 =
	'Enter a comment';
export const IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_ASSIGN_VARIANCE_REASON_INSTRUCTIONS_LINE_4 =
	'Select the ticket(s) to apply the variance to';
export const IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_ASSIGN_VARIANCE_REASON_INSTRUCTIONS_LINE_5 =
	'Press Apply';
export const IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_EXCLUDE_DATES_INSTRUCTIONS_LINE_1 =
	'If you want to update other ticket fields but leave the dates unchanged on pinned tickets:';
export const IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_EXCLUDE_DATES_INSTRUCTIONS_LINE_2 =
	'Set the mode select to "Exclude dates from update"';
export const IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_EXCLUDE_DATES_INSTRUCTIONS_LINE_3 =
	'Select the ticket(s) to exclude';
export const IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_EXCLUDE_DATES_INSTRUCTIONS_LINE_4 = 'Press Apply';
export const IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_ASSIGN_VARIANCE_ON_DATE_EXCLUDED =
	'Assigning a variance reason to a ticket that is set to be date excluded will cause its dates to be modified in accordance with the input file.';
export const IMPORT_TICKET_INSERTION_POINT_MISSING_MSG = 'Insertion point Y is missing.';
export const IMPORT_TICKET_RESULTS_TAB_TITLE = 'Results';
export const IMPORT_TICKET_RESULTS_SUCCESS_TITLE = 'Import complete';
export const IMPORT_TICKET_RESULTS_TICKETS_CREATED_UPDATED = (ticketsCreated, ticketsUpdated) => {
	let responseText = 'The import';
	if (ticketsCreated) {
		responseText += ` created ${ticketsCreated} new tickets`;
	}
	if (ticketsUpdated) {
		if (ticketsCreated) {
			responseText += ` and updated ${ticketsUpdated}`;
		} else {
			responseText += ` updated ${ticketsUpdated}`;
		}
	}
	return responseText;
};
export const IMPORT_TICKET_RESULTS_DEPENDENCIES_CREATED = (dependenciesCreated) =>
	`${dependenciesCreated} dependencies were created between tickets`;
export const IMPORT_TICKET_RESULTS_DEPENDENCIES_NOT_CREATED = (dependenciesNotCreated) =>
	`${dependenciesNotCreated} dependencies could not be made due to tickets not found on plan`;
export const IMPORT_TICKET_RESULTS_PLAN_UNLOCKED = 'The plan is now unlocked';
export const IMPORT_TICKET_RESULTS_SUCCESS_REVIEW_RESULTS = (snapShotInfo) =>
	`Please review the results of the import. A system snapshot was created prior to the import and can be used to undo the import: ${snapShotInfo}`;
export const IMPORT_TICKET_RESULTS_FAILURE_TITLE = 'Import Failed';
export const IMPORT_TICKET_RESULTS_FAILURE_IMPORT_INCOMPLETE =
	'An error ocurred that prevented the import from completing';
export const IMPORT_TICKET_RESULTS_FAILURE_PLAN_UNMODIFIED = 'The plan was not modified';
export const IMPORT_TICKET_ESID_DISAMBUGUATION_STEP_CREATE_NEW_TICKETS_FOR_ALL = 'Create new tickets for all';
export const IMPORT_TICKET_ESID_DISAMBUGUATION_STEP_UPDATE_ALL_TICKETS = 'Update all tickets';
export const IMPORT_TICKET_ESID_DISAMBUGUATION_STEP_CREATE_NEW_TICKET = 'Create new ticket';
export const IMPORT_TICKET_ESID_DISAMBUGUATION_STEP_SWIMLANE_LABEL = 'Swimlane';
export const IMPORT_TICKET_DATA_SOURCE_LABEL = 'Data source';
export const IMPORT_TICKET_DATA_SOURCE_TEXT = 'Create a data source for each system you import tickets from';
export const IMPORT_TICKET_DATA_SOURCE_LEAN_MORE_TITLE = 'Data Source';
export const IMPORT_TICKET_DATA_SOURCE_EDIT_BTN_TEXT = 'Edit Data Sources';
export const IMPORT_TICKET_DATA_SOURCE_LEAN_MORE_DESCRIPTION =
	"Data sources provide a way to manage the relationship between an external data source and Touchplan. When you import data into Touchplan associated with a Data Source the data import file often contains data that Touchplan can't directly import. Touchplan stores this additional information associated with your tickets for possible future use.";
export const IMPORT_TICKET_BS_ATTACHED_FILES_COUNT = (count) => `${count} Photos Attached`;
export const IMPORT_TICKET_BS_UPLOAD_MORE_BUTTON = 'Upload More';
export const IMPORT_TICKET_BS_UPLOAD_PHOTOS_BUTTON = 'Upload Photos';

//Import tickets error correction ui
export const IMPORT_TICKET_SKIP = 'Skip All';
export const IMPORT_TICKET_PLACE_TICKETS = (count: number) =>
	`Place ${count} Ticket${count > 1 || count === 0 ? 's' : ''}`;
export const IMPORT_TICKET_EXCLUDED_COUNT = (count: number) =>
	`${count} ticket${count > 1 || count === 0 ? 's' : ''} excluded`;
export const IMPORT_TICKET_CONFLICT_TAB = 'Conflicts';
export const IMPORT_TICKET_RESOLVED_TAB = 'Resolved Tickets';
export const IMPORT_TICKET_RESOLVE_BUTTON = 'Resolve';
export const IMPORT_TICKET_EXCLUDE_BUTTON = 'Exclude';
export const IMPORT_TICKET_BOARD_LABEL = 'Board';
export const IMPORT_TICKET_COLUMN_LABEL = 'Column';
export const IMPORT_TICKET_PLAN_START_REQUIRED = 'Start date is required';
export const IMPORT_ERROR_MESSAGE = "The import couldn't be completed at this time. Please try again.";
export const IMPORT_TICKET_ALL_EXCLUDED =
	'All tickets have been excluded. There are no tickets left to place.';
export const IMPORT_TICKET_BETWEEN_SMALL_ERROR = (min: number, max: number) => `Must be ${min}-${max}`;

export const MUST_BE_BEFORE_ACTIVE_LINE = (activeLineDate?: string) =>
	`Must be earlier than the active line${activeLineDate ? ` (${activeLineDate})` : ''}.`;
export const CLICK_TO_EXPAND = 'Click to expand';

// Image collection
export const IMAGE_COLLECTION_DEFAULT_UPLOAD_ERROR = 'Upload error';
export const IMAGE_COLLECTION_TITLE = 'Uploading Board Ticket Photos';
export const IMAGE_COLLECTION_LOADING_UPLOADING = 'Uploading your images...';
export const IMAGE_COLLECTION_LOADING_PROCESSING = 'Processing your tickets...';
export const IMAGE_COLLECTION_LOADING_PROCESSING_PERCENTAGE = (percentage) => `${percentage}% Complete`;
export const IMAGE_COLLECTION_DESCRIPTION =
	'Ensure your photos are in chronological order. If no start date is set, the system defaults to the current week.';
export const IMAGE_COLLECTION_PLAN_START_DATE_FIELD_LABEL = 'Plan Start Date';
export const IMAGE_COLLECTION_FILE_START_DATE = 'Start Date:';
export const IMAGE_COLLECTION_SAVE_OR_CLOSE_BUTTON = 'Upload and Process';
export const IMAGE_COLLECTION_INVALID_NUMBER_OF_IMAGES = 'You must upload between 1 and 20 files.';
export const IMAGE_COLLECTION_INVALID_IMAGES =
	'Some images have errors. Please replace or delete them before continuing';
export const IMAGE_COLLECTION_CLICK_TO_RELOAD_IMAGE = 'Click to reload image';
export const IMAGE_COLLECTION_RELOAD_IMAGE = 'Reload Image';

// Ticket export
export const EXPORT_TICKETS = 'Export Tickets';
// Reports UI
// ==========
// Report Types
export const REPORT_TYPE_LABEL_CONSTRAINT_LOG = 'Constraint Log';
export const REPORT_TYPE_LABEL_DRAFT_TICKETS = 'Draft Tickets';
export const REPORT_TYPE_LABEL_EXPORT_TO_CSV = 'Export to CSV';
export const REPORT_TYPE_LABEL_GANTT_CHART = 'Gantt Chart';
export const REPORT_TYPE_LABEL_OVERDUE_ACTIVITY = 'Overdue Activity';
export const REPORT_TYPE_LABEL_PPC_REPORT = 'PPC Report';
export const REPORT_TYPE_LABEL_SIX_WEEK_LOOK_AHEAD = 'Six-Week Look Ahead';
export const REPORT_TYPE_LABEL_WEEKLY_WORK_PLAN = 'Weekly Work Plan';
export const REPORT_TYPE_LABEL_BASIC_VARIANCE_REASON = 'Basic Variance Reason';
export const REPORT_TYPE_LABEL_ADVANCED_VARIANCE_REASON = 'Advanced Variance Reason';
export const REPORT_TYPE_LABEL_EXPORT_TICKETS = 'Export Tickets';
// Report Control Labels
export const REPORT_SORTBY_ROLE = 'Role';
export const REPORT_SORTBY_OFF = 'Off';
export const REPORT_SORTBY_LOCATION = 'Location';
export const REPORT_SORTBY_SWIMLANE = 'Swimlane';
export const REPORT_SORTBY_DATE = 'Date';
export const REPORT_SORTBY_WBS = 'WBS';
export const REPORT_TITLE = 'Reports';
export const REPORT_FILTERS = 'Filters';
export const REPORT_LAYOUT = 'Layout';
export const REPORT_TYPE = 'Report type';
export const REPORT_NUMBER_OF_WEEKS = 'Number of weeks';
export const REPORT_ALL_ROLES = 'All Roles';
export const REPORT_PLANS = 'Plans';
export const REPORT_ALL_PLANS = 'All Plans';
export const REPORT_ALL_LOCATIONS = 'All Locations';
export const REPORT_ALL_SWIMLANES = 'All Swimlanes';
export const REPORT_INCLUDE_COMPLETED_TICKETS = 'Include completed tickets';
export const REPORT_ONLY_LATE = 'Show only late constraints';
export const REPORT_INCLUDE_ARCHIVE_PLANS_INCREASE_GENERATION_TIME =
	'Including archived plans may increase report generation time';
export const REPORT_ARCHIVED_PLANS = 'Archived Plans';
export const REPORT_FILTER_BY_CUSTOM_FIELDS = 'Filter by custom fields';
export const REPORT_TIME_SCALE = 'Time scale';
export const REPORT_SORT_BY = 'Sort by';
export const REPORT_GROUP_BY = 'Group by';
export const REPORT_SORT_GROUPS_BY = 'Sort groups by';
export const REPORT_BREAK_UP_BY = 'Break up by';
export const REPORT_CSV_PLAN = 'Plan';
export const REPORT_CSV_PROJECT_LABEL = 'Project CSV';
export const REPORT_CSV_PROJECT_WITH_ARCHIVED_PLANS_LABEL = 'Project CSV with Archived Plans';
export const REPORT_CSV_PLAN_LABEL = 'Plan CSV';
export const REPORT_ALL_TICKET_TYPES = 'All ticket types';
export const REPORT_INCLUDE_PULL_TICKETS = 'Include pull tickets';
export const REPORT_EXTERNAL_SCHEDULE_ALL_TICKETS = 'All Tickets';
export const REPORT_WITH_EXTERNAL_SCHEDULE_ID = 'Only Tickets with External Schedule ID';
export const REPORT_WITHOUT_EXTERNAL_SCHEDULE_ID = 'Only Tickets without External Schedule ID';
export const REPORT_EXPORT_TICKETS_FORMAT = 'Export Format';
export const REPORT_EXPORT_TICKETS_FORMAT_TOUCHPLAN = 'Touchplan';
export const REPORT_EXPORT_TICKETS_FORMAT_P6 = 'P6 Primavera Excel';
export const REPORT_EXPORT_TICKETS_FORMAT_CSV = 'CSV';
export const REPORT_EXPORT_TICKETS_FORMAT_OPC = 'Primavera Cloud';
export const REPORT_EXPORT_TICKETS_FORMAT_MSP = 'MS Project Excel';
export const REPORT_EXPORT_TICKETS_FORMAT_BOARDSCAN = 'Board Scan';
export const REPORT_EXPORT_TEMPLATE_FORMAT_BUTTON = 'Choose Template';
export const REPORT_EXPORT_TEMPLATE_FORMAT_PLACEHOLDER = 'Schedule Template';
export const REPORT_EXPORT_TEMPLATE_INVALID_FORMAT = 'Invalid format, must be .xls or .xlsx';
export const REPORT_WBS_LEVEL = 'WBS Grouping Level';
export const REPORT_INCLUDE_WBS_CODE_TOGGLES_TEXT = 'Filter by WBS code';
export const REPORT_WBS_GROUPING_LEVEL_TEXT = 'WBS grouping level';
// Reports UI footer buttons
export const REPORT_EDIT_SETTINGS = 'Edit Settings';
export const REPORT_RUN_REPORT = 'Run Report';
export const REPORT_RUNNING_REPORT = 'Running Report';
export const REPORT_VIEW_REPORT = 'View Report';
export const REPORT_DOWNLOAD = 'Download';
// Reports UI: Errors
export const REPORT_ERROR_TITLE = 'Report error';
export const REPORT_ERROR_DESCRIPTION = 'Please try generating the report again.';
export const REPORT_ERROR_CUSTOMFIELD = 'Filter must be completely filled in';
// Time Scales:
export const TIME_SCALE_DAY = 'Day';
export const TIME_SCALE_WEEK = 'Week';
export const TIME_SCALE_QUARTER = 'Quarter';
// Report PPC formats
export const REPORT_PPC_FORMAT_PPC_BY_WEEK = 'PPC by Week';
export const REPORT_PPC_FORMAT_PPC_BY_ROLE = 'PPC by Role';
export const REPORT_PPC_FORMAT_PPC_BY_VARIANCE = 'PPC by Variance Reason';
export const REPORT_PPC_FORMAT_VARIANCE_BY_ROLE = 'Variance by Role';
export const REPORT_PPC_FORMAT_VARIANCE_BY_WEEK = 'Variance by Week';
export const REPORT_ERROR_REQUIRED = 'This field is required';
export const REPORT_ERROR_START_END_DATE = 'Start date must be before End date';

// Overdue billing
export const OVERDUE_BILLING_WARNING =
	'There is an issue with the billing on your account. Your access may be in jeopardy of being turned off.';
export const RESOLVE_ISSUE_CONTACT =
	'To resolve this issue. please contact us by clicking Support > Live Chat';

// "Edit Dependency" dialog
export const EDIT_DEPENDENCY_TITLE = 'Edit Dependency';
export const EDIT_DEPENDENCY_DIALOG_LAG_DAYS = 'Lag Days';
export const LINKAGE_TYPE_FINISH_TO_START = 'Finish to Start';
export const LINKAGE_TYPE_START_TO_START = 'Start to Start';
export const LINKAGE_TYPE_FINISH_TO_FINISH = 'Finish to Finish';
export const LINKAGE_TYPE_START_TO_FINISH = 'Start to Finish';

// Procore Authentication Flow
export const PROCORE_LOGIN_IS_REQUIRED = 'Procore Login is required.';
export const PROCORE_REDIRECTING_TO_PROCORE_SITE = 'Redirecting to Procore site... Please Wait.';
export const PROCORE_SUCCESSFULLY_LOGGED_IN = 'You have successfully logged in with Procore.';
export const PROCORE_PROJECT_ACCESS_DENIED_REAUTHENTICATE =
	'Access to this Procore project is restricted. Please re-authenticate to continue.';
export const PROCORE_TOKEN_REFRESHED = 'Procore token refreshed.';

// LOGIN PAGE ITEMS
export const WIZARD_CONTINUE = 'Continue';
export const PHONE_QUERY = 'On a phone?';
export const DESKTOP_QUERY = 'On a desktop computer?';
export const MOBILE_REDIRECT = 'Go to mobile site';
export const DESKTOP_REDIRECT = 'Go to desktop site';
export const FORGOT_PASSWORD = 'Forgot password';
export const META_DESKTOP_TITLE = 'Touchplan Desktop Access';
export const META_MOBILE_TITLE = 'Touchplan Mobile Access';
export const META_DESKTOP_DESCRIPTION = `Touchplan's desktop version allows you to easily track and analyze jobsite factors and virtually plan and map out your project.`;
export const META_MOBILE_DESCRIPTION =
	'With Touchplan Mobile, you can bring your project plans anywhere and send status updates while on the jobsite.';

// RESET PASSWORD PAGE
export const RESET_PASSWORD_HEADING = 'Reset Password';
export const RESET_PASSWORD_DESCRIPTION =
	'To reset your password, enter your account email address here. Check your inbox and your spam messages, you should receive a reset link within minutes!';
export const RESET_PASSWORD_HELP_LINK = 'Having problems?';
export const RESET_PASSWORD_SUBMIT_TEXT =
	'If this user exists, an email will be sent with instructions on how to change your password. Redirecting back to log in...';

// DUPLICATED FROM MOBILE'S STRINGS
// becase that also exists for who the hell knows what reason
export const LOG_IN = 'Log In';
export const SIGN_UP = 'Sign Up';
export const PASSWORD = 'Password';
export const EMAIL_PASSWORD_INCORRECT = 'Email or password is incorrect';
export const ENTER_VALID_EMAIL = 'Enter a valid email';
export const EMAIL = 'Email';
export const ALREADY_HAVE_ACCOUNT = 'Already have an account?';
export const NEW_TO_TOUCHPLAN = 'New to Touchplan?';
export const LOG_IN_SUCCESS = 'Log in successful';

// TENANT MIGRATION
export const TENANT_MIGRATION_HEADER = 'The way you log into Touchplan is changing.';
export const TENANT_MIGRATION_DESCRIPTION = `Your account is changing to use the login system from your employer/project owner called Single Sign-On, or SSO.This is a 3 step process.`;
export const TENANT_MIGRATION_AUTHED_TEXT = 'Logged in as';
export const TENANT_MIGRATION_SSO_LOGIN_BUTTON = 'Launch SSO';
export const TENANT_MIGRATION_PASSWORD_REQUIRED = 'Required';
export const TENANT_MIGRATION_STEP_1 = 'Step 1';
export const TENANT_MIGRATION_STEP_2 = 'Step 2';
export const TENANT_MIGRATION_STEP_3 = 'Step 3';
export const TENANT_MIGRATION_SRC_DESCRIPTION =
	'Log into your Touchplan account using the username and password you set in the Touchplan application.';
export const TENANT_MIGRATION_TARGET_DESCRIPTION =
	'Log into the Single Sign-On system.  This may open in a new browser window.';
export const TENANT_MIGRATION_WAITING_LINE1 = 'We’re migrating your Touchplan account.';
export const TENANT_MIGRATION_WAITING_LINE2 = 'This process can take up to 10 minutes.';
export const TENANT_MIGRATION_WAITING_LINE3 = 'Your browser will refresh at the end of this process.';
export const TENANT_MIGRATION_WAITING_LINE4 =
	'Use your SSO account credentials whenever you log into Touchplan from now on.';
export const TENANT_MIGRATION_SUCCESS_MSG = 'Migration process successful, redirecting shortly.';
export const TENANT_MIGRATION_COMPLETE_MSG = 'Migration completed, redirecting...';
export const TENANT_MIGRATION_ERROR_MSG = 'Migration process failed, please try again later.';
export const MORPH_USER_TENANT_MIGRATION_ERROR_MSG =
	'Unable to morph user due to an ongoing migration process.';

// SIGN UP PAGE ITEMS
export const SIGN_UP_TITLE = 'Create a new account';
export const SIGN_UP_SUBTITLE =
	'Please fill out all of the required fields below to create an account with us.';
export const SIGN_UP_FORM_FIRST_NAME = 'First Name';
export const SIGN_UP_FORM_LAST_NAME = 'Last Name';
export const SIGN_UP_FORM_COMPANY = 'Company';
export const SIGN_UP_FORM_TELEPHONE = 'Telephone';
export const SIGN_UP_FORM_PASSWORD = 'Password';
export const SIGN_UP_FORM_CONFIRM_PASSWORD = 'Confirm Password';
export const SIGN_UP_FORM_TITLE = 'Title';
export const SIGN_UP_NEXT_BTN = 'Next';
export const SIGN_UP_CANCEL_BTN = 'Cancel';
export const FIELD_IS_REQUIRED = 'This field is required';
export const FIELD_NO_EMPTY_STRING = 'This field cannot contain only spaces';
export const TERMS_CONDITIONS_MUST_BE_ACCEPTED = 'terms and conditions must be accepted';

export const SIGN_UP_ADDITION_TO_PROJECTS_FAILED_TITLE = (count) =>
	`Adding you to project${count > 1 ? 's' : ''} failed`;
export const SIGN_UP_ADDITION_TO_PROJECTS_FAILED_MESSAGE = (count, projectNames) =>
	`Adding you to the following project${
		count > 1 ? 's' : ''
	} failed. Please contact the administrators of the project${count > 1 ? 's' : ''}: ${projectNames}`;
export const SIGN_UP_VALIDATION_USER_HAS_PENDING_MIGRATION = 'The user has pending migration, please log in.';

// SSO verification
export const SSO_VERIFICATION_TITLE = (time: string) => `Page will refresh for SSO verification at ${time}`;
export const SSO_VERIFICATION_BUTTON = 'Verify now without refresh';
export const SSO_VERIFICATION_SUCCESS = 'SSO verification successful';

// BANNER MESSAGES
export const BANNER_MESSAGE_ERROR_TITLE = 'Error';
export const BANNER_MESSAGE_WARNING_TITLE = 'Warning';
export const BANNER_MESSAGE_INFO_TITLE = 'Info';
export const BANNER_MESSAGE_SUCCESS_TITLE = 'Success';
export const BANNER_MESSAGE_EMAIL_ALREADY_EXISTS =
	'The provided email is already in use by an existing user. Each user must have a unique email.';
export const BANNER_MESSAGE_INVALID_ARGUMENT =
	'An invalid argument was provided to an Authentication method.';
export const BANNER_MESSAGE_INVALID_PASSWORD = 'The password is invalid.';
export const BANNER_MESSAGE_PHONE_NUMBER_ALREADY_EXISTS =
	'The provided phone number is already in use. Each user must have a unique phone number.';
export const BANNER_MESSAGE_DEFAULT_ERROR_MESSAGE = 'Something went wrong, try again later';
export const BANNER_MESSAGE_DEFAULT_LOGIN_ERROR_MESSAGE = 'An error occurred during login, try again later.';
export const BANNER_MESSAGE_INVALID_USERNAME_OR_PASSWORD =
	'The username or password you entered was incorrect. Please try again.';
export const BANNER_MESSAGE_PASSWORD_DOES_NOT_MEET_REQUIREMENTS = 'Password does not meet requirements';
export const BANNER_MESSAGE_TOO_MANY_AUTH_REQUESTS_ERROR_MESSAGE =
	'This account is locked out due to repeated incorrect login attempts; please wait and try again later';
export const BANNER_MESSAGE_REPEATED_LOGIN_WARNING_MESSAGE =
	'Repeat login failures will result in account lockout';
export const BANNER_MESSAGE_NON_PRODUCTION_INSTANCE = 'This is a non-production instance';

// ERROR MESSAGES
export const PASSWORD_ERROR_MIN = 'Must be at least 10 characters long';
export const CONFIRM_PASSWORD_ERROR = 'Confirm Password must match Password';
export const PASSWORD_ERROR_PATTERN = 'Password does not meet requirements';

// RALLY POINT
export const RALLY_POINT_CODE_INVALID = 'Access code is invalid.';
export const RALLY_POINT_CODE_EXPIRED = 'Access code has expired.';
export const RALLY_POINT_CODE_MUST_PROVIDED = 'You must enter a code.';
export const RALLY_POINT_TITLE = 'Let’s join an existing plan.';
export const RALLY_POINT_BODY =
	'Please enter the access code below. This access code was provided to you by your plan administrator. If you do not have one, please contact the plan administrator.';
export const RALLY_POINT_ACCESS_CODE_LABEL = 'Access Code';
export const RALLY_POINT_ACCESS_CODE_CANCEL_BTN = 'Cancel';
export const RALLY_POINT_ACCESS_CODE_NEXT_BTN = 'Next';
export const RALLY_POINT_ACCESS_ALREADY_LOGGED_TEXT1 = 'Hello ';
export const RALLY_POINT_ACCESS_ALREADY_LOGGED_TEXT2 = `, I see that you're already logged intoTouchplan.`;
export const RALLY_POINT_ACCESS_ALREADY_LOGGED_TEXT3 = `When you hit next, I'll send you straight to the rally point.`;

// PROFILE PAGE
export const PROFILE_NEXT_BTN = 'Update';
export const PROFILE_ZIP_CODE = 'Zip Code';
export const PROFILE_NEW_PASSWORD = 'New Password';
export const PROFILE_PAGE_TITLE = 'Manage Your Account';
export const PROFILE_TITLE_PLACEHOLDER = 'Select a title';
export const PROFILE_CURRENT_PASSWORD = 'Current Password';
export const PROFILE_UPDATE_ERROR = 'Account profile update failed';
export const PROFILE_UPDATE_PASSWORD_ERROR = 'Password update failed';
export const PROFILE_UPDATE_SUCCESS = 'Account profile updated successfully';
export const PROFILE_UPDATE_PASSWORD_SUCCESS = 'Password updated successfully';

// TOUCHPLAN STATUS PAGE
export const STATUS_PAGE_TITLE = 'Checking your connection to Touchplan';
export const TESTS_BIT_DATA_DESCRIPTION = 'Reading a bit of data...';
export const TESTS_BIG_DATA_DESCRIPTION = 'Reading a lot of data...';
export const TESTS_WRITING_DATA_DESCRIPTION = 'Writing some data...';
export const TESTS_CHECKING_AUTH_DESCRIPTION = 'Checking for auth...';
export const TESTS_CHECKING_AUTH_API = 'Checking for auth api...';
export const TESTS_CLOUD_FUNCTION_DESCRIPTION = 'Checking for cloud function connectivity...';
export const TESTS_CLOUD_AUTH_FUNCTION_DESCRIPTION =
	'Checking for cloud function connectivity with Authentication...';
export const TESTS_URL_DESCRIPTION = 'Checking for required URLs...';
export const TESTS_GCS_ACCESS_PERMISSIONS =
	'(Requires Authentication) Checking Cloud Storage file upload and download permissions...';

// INSERTION POINT

export const INSERTION_POINT_TEXTURES_LABEL = 'Ticket Insertion Point';

// Project Settings / Data Sources
export const DATA_SOURCES_TITLE = 'Data Sources';
export const DATA_SOURCES_DESCRIPTION =
	'Associate data imported into Touchplan with their origin using Data Sources';
export const DATA_SOURCES_NAME_FIELD_LABEL = 'Data Source Name';
export const DATA_SOURCES_TYPE_FIELD_LABEL = 'Data Source Type';
export const DATA_SOURCES_DATE_FORMAT_LABEL = 'Data Source Date Format';
export const DATA_SOURCES_WBS_FIELD_LABEL = 'WBS Separator';
export const DATA_SOURCES_SCHEDULE_TEMPLATE_FIELD_LABEL = 'Schedule Template';
export const DATA_SOURCES_CREATE_NEW_ITEM = 'Create new data source';
export const DATA_SOURCES_CREATE_MESSAGE = 'Data source created!';
export const DATA_SOURCES_UPDATE_MESSAGE = 'Data source updated!';
export const DATA_SOURCES_NAME_VALIDATION_ERROR_MESSAGE = 'Name already exists';
export const DATA_SOURCES_SELECTOR_HINT_TEXT = 'View existing data sources or create a new one';
export const DATA_SOURCES_SELECTOR_FIELD_DESCRIPTION =
	'Select between all of your existing data sources that have been created for this project or create a new data source.';
export const DATA_SOURCES_NAME_HINT_TEXT = 'Name of your data source';
export const DATA_SOURCES_NAME_FIELD_DESCRIPTION = 'The name of the data source to identify at a glance.';
export const DATA_SOURCES_TYPE_SELECTOR_HINT_TEXT = 'The system your data is coming from';
export const DATA_SOURCES_DATE_FORMAT_HINT_TEXT =
	'The date format of external system your data is coming from';
export const DATA_SOURCES_TYPE_SELECTOR_FIELD_DESCRIPTION =
	'This identifies the system that your data originates from to allow for correct mapping of the data.';
export const DATA_SOURCES_DATE_FORMAT_SELECTOR_FIELD_DESCRIPTION =
	'This identifies the date format being used in MS Project.';
export const DATA_SOURCES_WBS_HINT_TEXT = 'The character that separates your WBS structure';
export const DATA_SOURCES_WBS_FIELD_DESCRIPTION =
	'The separator is the single character that denotes the next level, or separation, of the WBS structure defined in your project.';
export const DATA_SOURCES_P6_WBS_SEPARATOR_REQUIRED_ERROR_MESSAGE =
	'WBS separator is required for P6 Excel data sources';
export const DATA_SOURCES_OPC_WBS_SEPARATOR_REQUIRED_ERROR_MESSAGE =
	'WBS separator is required for Primavera Cloud data sources';

// Project Settings / Time and Schedule
export const TIME_AND_SCHEDULE_TITLE = 'Time and Schedule Settings';
// Start date
export const TIME_AND_SCHEDULE_START_DATE = 'Start Date';
export const TIME_AND_SCHEDULE_START_DATE_DESCRIPTION =
	'Select the Monday that will be used as Week 1 in the project timeline. Only Mondays are allowed.';
export const TIME_AND_SCHEDULE_START_DATE_HINT = 'Set Starting Week';
export const TIME_AND_SCHEDULE_START_DATE_ERROR = 'Please select a Monday';
export const TIME_AND_SCHEDULE_LOADED = `${TIME_AND_SCHEDULE_TITLE} loaded`;
export const TIME_AND_SCHEDULE_LOAD_FAILED = (err) => `Cannot load ${TIME_AND_SCHEDULE_TITLE} : ${err}`;
export const TIME_AND_SCHEDULE_SAVED = `${TIME_AND_SCHEDULE_TITLE} saved`;
export const TIME_AND_SCHEDULE_SAVE_FAILED = (err) => `Cannot save ${TIME_AND_SCHEDULE_TITLE} : ${err}`;
// Schedule view
export const TIME_AND_SCHEDULE_SCHEDULE_VIEW = 'Schedule View';
export const TIME_AND_SCHEDULE_SCHEDULE_VIEW_DESCRIPTION =
	'Set how your work schedule works. The timeline will adjust to show and plan work days based on your choice.';
// Weekly schedule
export const TIME_AND_SCHEDULE_WEEKLY_SCHEDULE_VIEW = 'Weekly Schedule';
export const TIME_AND_SCHEDULE_WEEKLY_SCHEDULE_VIEW_LONG =
	'Weekly Schedule - Mon, Tue, Wed, Thu, Fri, Sat, Sun';
export const TIME_AND_SCHEDULE_WEEKLY_SCHEDULE_VIEW_DESCRIPTION =
	'A 7-day cycle aligned with the calendar week. Monday -Sunday ';
export const TIME_AND_SCHEDULE_WEEKLY_SCHEDULE_VIEW_CONFIGURATION = 'Weekly Schedule Configuration';
// Custom schedule
export const TIME_AND_SCHEDULE_CUSTOM_SCHEDULE_VIEW = 'Custom Schedule ';
export const TIME_AND_SCHEDULE_CUSTOM_SCHEDULE_VIEW_DESCRIPTION =
	'A custom cycle based on a set number of days (e.g 10 on / 5 off). Does not follow the calendar week and requires a start date.';
export const TIME_AND_SCHEDULE_CUSTOM_SCHEDULE_VIEW_CONFIGURATION = 'Custom Schedule Configuration';
export const TIME_AND_SCHEDULE_CUSTOM_SCHEDULE_ADD = '+ Add  a Schedule';
export const TIME_AND_SCHEDULE_CUSTOM_SCHEDULE_DELETE = (name: string) => `Delete ${name}`;
export const TIME_AND_SCHEDULE_CUSTOM_SCHEDULE_SAVE = (name: string) => `Save ${name}`;
export const TIME_AND_SCHEDULE_CUSTOM_SCHEDULE_SELECTION_LABEL = 'Choose Schedule Configuration';
export const TIME_AND_SCHEDULE_CUSTOM_SCHEDULE_DESCRIPTION = 'Description';
export const TIME_AND_SCHEDULE_CUSTOM_SCHEDULE_START_DATE = 'Start Date';
export const TIME_AND_SCHEDULE_CUSTOM_SCHEDULE_PREVIEW = 'Schedule Preview';
export const TIME_AND_SCHEDULE_CUSTOM_SCHEDULE_WORK_DAYS = 'Work Days';
export const TIME_AND_SCHEDULE_CUSTOM_SCHEDULE_NON_WORK_DAYS = 'Non Work Days';
export const TIME_AND_SCHEDULE_CUSTOM_SCHEDULE_SHIFTS = 'Working Days and Workshifts';
export const TIME_AND_SCHEDULE_WORKING_DAYS = 'Working Days';
export const TIME_AND_SCHEDULE_WORKSHIFTS = 'Workshifts';
export const TIME_AND_SCHEDULE_CUSTOM_SCHEDULE_DAY = (index) => `Day ${index}`;
export const TIME_AND_SCHEDULE_CUSTOM_SCHEDULE_NOT_WORKING = 'Not Working';
// Role work schedule
export const TIME_AND_SCHEDULE_ROLE = 'Role';
export const TIME_AND_SCHEDULE_WORK_SCHEDULE = 'Work Schedule';
// Non work days
export const TIME_AND_SCHEDULE_NON_WORK_DAYS = 'Non Work Days';
export const TIME_AND_SCHEDULE_NON_WORK_DAYS_DESCRIPTION =
	'Add exceptions to your project’s work schedule, such as holidays or planned shutdowns. These global non-working days apply to all plans and cannot be overridden by Plan Work Schedules.';
export const TIME_AND_SCHEDULE_NON_WORK_DAYS_NON_WORKING_DAY = 'Non Working Day';
export const TIME_AND_SCHEDULE_NON_WORK_DAYS_DATE = 'Date';
export const TIME_AND_SCHEDULE_NON_WORK_DAYS_ADD_NEW = '+ Add Non Working Day';
export const TIME_AND_SCHEDULE_NON_WORK_DAYS_DELETE = (name: string) => `Delete ${name}`;
export const TIME_AND_SCHEDULE_NON_WORK_DAYS_EDIT = (name: string) => `Edit ${name}`;
export const TIME_AND_SCHEDULE_NON_WORK_DAYS_UNSAVED_CHANGES =
	'You have unsaved changes. Please save or delete the unsaved non working day.';

// Milestone Types
export const TICKET_MILESTONE_TYPE_PLACEHOLDER = 'Select a Milestone Type';

// General purpose filters
export const FILTER_BY_EXTERNAL_SCHEDULE_ID = 'External Schedule ID';
export const FILTER_BY_CUSTOM_FIELDS = 'Custom Fields';
export const FILTER_CUSTOM_FIELD_FILTER_1 = 'Custom Field Filter 1';
export const FILTER_CUSTOM_FIELD_FILTER_2 = 'Custom Field Filter 2';
export const FILTER_CUSTOM_FIELD_FILTER_3 = 'Custom Field Filter 3';
export const FILTER_AND_OPERATOR = 'AND';
export const FILTER_OR_OPERATOR = 'OR';

// Plan Tickets Filter
export const PLAN_FILTER_TITLE = 'Search and filter';
export const PLAN_FILTER_OPERATOR_PLACEHOLDER = 'Filter logic';
export const PLAN_FILTER_BY_DESCRIPTION = 'description';
export const PLAN_FILTER_BY_ATTACHMENT_COMMENT = 'Attachment Comment';
export const PLAN_FILTER_TICKET_LIST_SORT = 'Sort by';
export const PLAN_FILTER_TICKET_STATUS = 'Ticket status';
export const PLAN_FILTER_TICKET_ATTACHMENT = 'Ticket attachment';
export const PLAN_FILTER_ERROR_CUSTOMFIELD = 'Filter must be completely filled in';
export const PLAN_FILTER_BY = (filterBy) => `Filter by ${filterBy}`;
export const PLAN_FILTER_ALL = (filterAll) => `Filter by ${filterAll}`;
export const PLAN_FILTER_TICKET_LIST_SORT_BY_START_DATE_ASC = 'Start date ascending';
export const PLAN_FILTER_TICKET_LIST_SORT_BY_START_DATE_DESC = 'Start date descending';
export const PLAN_FILTER_TICKET_LIST_TITLE = 'Ticket List';
export const PLAN_FILTER_TICKET_ATTACHMENT_ALL_TICKET_OPTION = 'All tickets';
export const PLAN_FILTER_TICKET_WITH_ATTACHMENTS_OPTION = 'Only tickets with attachments';
export const PLAN_FILTER_TICKET_WITHOUT_ATTACHMENTS_OPTION = 'Only tickets without attachments';
export const TODAY_LINE_LABEL_TEXT = `Today:`;

export const MILESTONE_LINE_LABEL_TEXT = `Milestone:`;
export const ACTIVE_LINE_LABEL_TEXT = `Active:`;

//--------- Plan Print ----------//
export const PLAN_PRINT_TITLE = 'Plan Print';
export const PLAN_PRINT_FILTERS_ACTION = 'Filters';
export const PLAN_PRINT_ACTION = 'Print';
export const PLAN_PRINT_INVALID_PRINT_DIMENSION =
	'The selected dimensions exceed the maximum printable area.';
export const PLAN_PRINT_INVALID_WIDTH = 'Invalid Width';
export const PLAN_PRINT_INVALID_HEIGHT = 'Invalid Height';
export const PLAN_PRINT_DIALOG_TITLE = 'Generating printable plan';
export const PLAN_PRINT_DIALOG_CANCEL_BUTTON = 'Cancel Print';
// DPI
export const PLAN_PRINT_SETTINGS_DPI_LABEL = 'DPI';
// Height
export const PLAN_PRINT_SETTINGS_HEIGHT_LABEL = 'Height';
// Orientation
export const PLAN_PRINT_SETTINGS_ORIENTATION_LABEL = 'Orientation';
export const PLAN_PRINT_SETTINGS_ORIENTATION_LANDSCAPE = 'Landscape';
export const PLAN_PRINT_SETTINGS_ORIENTATION_PORTRAIT = 'Portrait';
// Page size
export const PLAN_PRINT_SETTINGS_PAGE_SIZE_LABEL = 'Page Size';
export const PLAN_PRINT_SETTINGS_PAGE_SIZE_ARCH_A = 'ARCH A (9 × 12)';
export const PLAN_PRINT_SETTINGS_PAGE_SIZE_ARCH_B = 'ARCH B (12 × 18)';
export const PLAN_PRINT_SETTINGS_PAGE_SIZE_ARCH_C = 'ARCH C (18 × 24)';
export const PLAN_PRINT_SETTINGS_PAGE_SIZE_ARCH_D = 'ARCH D (24 × 36)';
export const PLAN_PRINT_SETTINGS_PAGE_SIZE_ARCH_E = 'ARCH E (36 × 48)';
export const PLAN_PRINT_SETTINGS_PAGE_SIZE_ARCH_E1 = 'ARCH E1 (30 × 42)';
export const PLAN_PRINT_SETTINGS_PAGE_SIZE_ANSI_A = 'ANSI A (8.5 × 11)';
export const PLAN_PRINT_SETTINGS_PAGE_SIZE_ANSI_B = 'ANSI B (11 × 17)';
export const PLAN_PRINT_SETTINGS_PAGE_SIZE_ANSI_C = 'ANSI C (17 × 22)';
export const PLAN_PRINT_SETTINGS_PAGE_SIZE_ANSI_D = 'ANSI D (22 × 34)';
export const PLAN_PRINT_SETTINGS_PAGE_SIZE_ANSI_E = 'ANSI E (34 × 44)';
export const PLAN_PRINT_SETTINGS_PAGE_SIZE_US_LETTER = 'Letter (8.5 × 11)';
export const PLAN_PRINT_SETTINGS_PAGE_SIZE_US_LEGAL = 'Legal (8.5 × 14)';
export const PLAN_PRINT_SETTINGS_PAGE_SIZE_US_TABLOID = 'Tabloid (11 × 17)';
export const PLAN_PRINT_SETTINGS_PAGE_SIZE_US_LEDGER = 'Ledger (17 × 11)';
export const PLAN_PRINT_SETTINGS_PAGE_SIZE_A0 = 'A0 (33.1 × 46.8)';
export const PLAN_PRINT_SETTINGS_PAGE_SIZE_A1 = 'A1 (23.4 × 33.1)';
export const PLAN_PRINT_SETTINGS_PAGE_SIZE_A2 = 'A2 (16.5 × 23.4)';
export const PLAN_PRINT_SETTINGS_PAGE_SIZE_A3 = 'A3 (11.7 × 16.5)';
export const PLAN_PRINT_SETTINGS_PAGE_SIZE_A4 = 'A4 (8.3 × 11.7)';
export const PLAN_PRINT_SETTINGS_PAGE_SIZE_CUSTOM = 'Custom';
// Role legend
export const PLAN_PRINT_SETTINGS_ROLE_LEGEND_LABEL = 'Role Legend';
export const PLAN_PRINT_SETTINGS_ROLE_LEGEND_BOTTOM_LEFT = 'Bottom Left';
export const PLAN_PRINT_SETTINGS_ROLE_LEGEND_BOTTOM_RIGHT = 'Bottom Right';
export const PLAN_PRINT_SETTINGS_ROLE_LEGEND_NONE = 'None';
export const PLAN_PRINT_SETTINGS_ROLE_LEGEND_TOP_LEFT = 'Top Left';
export const PLAN_PRINT_SETTINGS_ROLE_LEGEND_TOP_RIGHT = 'Top Right';
// Text size
export const PLAN_PRINT_SETTINGS_TEXT_SIZE_LABEL = 'TextSize';
export const PLAN_PRINT_SETTINGS_TEXT_SIZE_SMALL = 'Small';
export const PLAN_PRINT_SETTINGS_TEXT_SIZE_MEDIUM = 'Medium';
export const PLAN_PRINT_SETTINGS_TEXT_SIZE_LARGE = 'Large';
// Units
export const PLAN_PRINT_SETTINGS_UNITS_LABEL = 'Units';
export const PLAN_PRINT_SETTINGS_UNITS_IN = 'inches';
export const PLAN_PRINT_SETTINGS_UNITS_PX = 'pixels';
// Width
export const PLAN_PRINT_SETTINGS_WIDTH_LABEL = 'Width';
export const PLAN_PRINT_ROLE_LEGEND_LABEL = 'Role Legend';
// Capture and upload
export const PLAN_PRINT_CAPTURE_UPLOAD_ERROR = 'Print export failed, please try again.';

//-------------------------------------------------- END OF STRING CONSTANTS COMING FROM FRONTEND FILE --------------------------------------------------

//-------------------------------------------------- START OF STRING CONSTANTS COMING FROM MOBILE FILE --------------------------------------------------
export const PAGE_TITLE_PROJECTS = 'Projects';
export const PAGE_TITLE_PLANS = 'Plans';
export const PAGE_TITLE_ALL_PLANS = 'All Plans';
export const PAGE_TITLE_PLAN_TICKETS = 'Plan Tickets';

// Plan list
export const PLANS_LIST_ALL_PLANS = 'All Plans';
export const PLANS_COUNT = 'Active Plans';

// Header Menu Items
export const SUPPORT = 'Support';
export const ENTER_ACCESS_CODE = 'Enter access code';
export const LOGOUT = 'Log out';
export const SWITCH_TO_DESKTOP = 'Switch to desktop app';
export const LOG_IN_AS = 'Logged in as';

// Side Navigation Items
export const SORT_AND_FILTER = 'Sort and filter';
export const SORT_BY = 'Sort by';
export const FILTER_BY = 'Filter by';
export const STATUS = 'Status';
export const TODO = 'To do';
export const COMPLETED = 'Completed';
export const ROLES = 'Roles';
export const ALL_ROLES = 'All Roles';
export const MY_ROLES = 'My Roles';
export const LOCATIONS = 'Locations';
export const ALL_LOCATIONS = 'All Locations';
export const NO_LOCATION = '<No Location>';
export const ALL_STATUSES = 'All Statuses';

// Side Navigation Sort options
export const START_DATE = 'Start date';
export const END_DATE = 'End date';

export const LOOKING_FOR_TICKETS = 'Looking for tickets...';
export const NO_MATCHING_TICKETS = 'No matching tickets on this plan.';
export const CHANGE_FILTERS = 'Try changing your filters.';

// Ticket footer buttons
export const UPDATE_STATUS = 'Update Status';
export const START_WORK = 'Start Work';
export const SHOW_PLANNED_VALUES = 'SHOW PLANNED VALUES';
export const SAVE = 'SAVE';
export const CLOSE = 'CLOSE';
export const CANCEL = 'CANCEL';

export const CHECKED = 'checked';
export const UNCHECKED = 'unchecked';
export const INDETERMINATE = 'indeterminate';

export const START_DATE_BIGGER_THEN_FINISH_DATE_ERR = `Start must be before Finish`;
export const FINISH_DATE_BIGGER_THEN_ACTIVE_LINE_DATE = 'Finish must be before Active Line';
/**
 * TP-6739: This is intended to be used with the `UNABLE_TO_PERFORM_ACTION_BECAUSE_NOT_ADMIN` helper function
 * to inform the user why they cannot set a new promise period. Old logging message was originally buried in
 * the AngularJS scopeSoup.
 */
export const ACTION_SET_NEW_PROMISE_PERIOD = `set new promise period`;
export const PROMISE_PERIOD_ID_NOT_FOUND = `Unable to lock promise period because the period was not found.`;
export const PROMISE_PERIOD_ALREADY_LOCKED = `Unable to lock promise period because it is already locked.`;
export const PROMISE_PERIOD_NO_ACCESS = `You do not have access. Please contact your project Admin.`;
export const PROMISE_PERIOD_ERROR_ON_SNAPSHOT = 'Error taking snapshot before locking promise period.';

export const PROMISE_PERIOD_NEXT_PERIOD = `NEXT PERIOD`;
export const PROMISE_PERIOD_LAST_PERIOD = `CURRENT PERIOD`;
//-------------------------------------------------- END OF STRING CONSTANTS COMING FROM MOBILE FILE --------------------------------------------------
